import React, { useState, useEffect, useRef, useMemo } from 'react';
// Corrected: Using esm.sh to import Stripe modules from a CDN-like service
// This resolves the issue where the bundler cannot find the local packages.
import { loadStripe } from '@stripe/stripe-js';
import {
    Elements,
    PaymentElement,
    useStripe,
    useElements
} from '@stripe/react-stripe-js';

// --- Stripe Configuration ---

//local

// const API_BASE_URL = 'http://localhost:8080/api';
// const stripePromise = loadStripe('pk_test_51RqQQ0EbrREGulb3IuPCD56nifgtRYsgndW4f53SmSTdQRI7QfjVlCGnzZL5MyPoKXMsleeQefKWd0GG9U93bUjR00Ql6QkBBy');

//prod
const API_BASE_URL = 'https://api.smartmathedu.com/api';
const stripePromise = loadStripe('pk_live_51QcbXoEakfmFz2DcxMxZ2JLRJyfDcbC0qIV8XEAjkGmDwpH1ToCPy3zX1OofBPsPeiqXHMdaIAkhSqL7EE2gsOw40049Plrlt2');


// --- API Helper ---
// A centralized fetch function to automatically include the auth token
const apiFetch = async (url, options = {}, token) => {
    const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE_URL}${url}`, {
        ...options,
        headers,
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'An unknown error occurred' }));
        console.error('API Error:', response.status, errorData);
        throw new Error(errorData.message || `Request failed with status ${response.status}`);
    }

    if (response.status === 204) {
        return;
    }

    // Try to parse JSON, but handle cases where body is empty or not JSON
    const text = await response.text();
    try {
        return JSON.parse(text);
    } catch (err) {
        // If JSON.parse fails, it's not a JSON response.
        // Return the raw text if it's not empty, otherwise return null.
        return text ? text : null;
    }
};

// --- NEW: Landing Page Component ---
const LandingPage = ({ setCurrentPage, isLoggedIn }) => {
    const handleEnrollClick = () => {
        if (isLoggedIn) {
            setCurrentPage('enrollment');
        } else {
            setCurrentPage('registration');
        }
    };

    return (
        <div>

            <section id="home" className="relative gradient-bg py-20 md:py-32">
                <div className="container mx-auto px-4 grid md:grid-cols-2 gap-12 items-center">
                    {/*<div className="fade-in">*/}
                    {/* <span className="text-primary font-semibold text-lg">Welcome to SmartMath</span>*/}
                    {/* <h1 className="text-4xl md:text-5xl font-extrabold text-dark my-4 leading-tight">*/}
                    {/* Unlock Your Child's Potential in Math*/}
                    {/* </h1>*/}
                    {/* <p className="text-gray-600 text-lg mb-8">*/}
                    {/* Personalized tutoring designed to build confidence, deepen understanding, and achieve*/}
                    {/* exceptional results.*/}
                    {/* </p>*/}
                    {/* <div className="flex flex-col sm:flex-row gap-4">*/}
                    {/* <button onClick={handleEnrollClick}*/}
                    {/* className="bg-primary text-white px-8 py-3 rounded-button font-semibold hover:bg-primary/90 transition shadow-lg">Enroll*/}
                    {/* Now*/}
                    {/* </button>*/}
                    {/* <a href="#courses"*/}
                    {/* className="bg-white text-primary border-2 border-primary px-8 py-3 rounded-button font-semibold hover:bg-light transition">Explore*/}
                    {/* Courses</a>*/}
                    {/* </div>*/}
                    {/*</div>*/}
                    <div className="animate-fade-in-up">
                        <span className="text-primary font-medium mb-4 inline-block">Welcome to SmartMath</span>
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">Transform
                            Your Math Journey With Expert Guidance</h1>
                        <p className="text-lg text-gray-700 mb-8 leading-relaxed">Unlock your mathematical potential
                            with
                            personalized tutoring that builds confidence, deepens understanding, and delivers
                            exceptional
                            results.</p>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <button onClick={handleEnrollClick}
                                    className="bg-primary text-white px-8 py-3.5 !rounded-button font-medium hover:bg-primary/90 transition text-center whitespace-nowrap group">Start Learning Today</button>
                            <a href="#courses"
                               className="bg-white text-primary border-2 border-primary px-8 py-3.5 !rounded-button font-medium hover:bg-gray-50 transition text-center whitespace-nowrap">Explore
                                Programs</a>
                        </div>
                        <div className="mt-12 flex items-center gap-8">
                            <div className="flex items-center gap-2">
                                <i className="ri-user-star-line text-primary text-2xl"></i>
                                <div>
                                    <p className="font-semibold text-gray-900">Certified Tutors</p>
                                    <p className="text-sm text-gray-600">Masters and Ed Degree</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                <i className="ri-award-line text-primary text-2xl"></i>
                                <div>
                                    <p className="font-semibold text-gray-900">99% Success Rate</p>
                                    <p className="text-sm text-gray-600">Grade Improvement</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="relative hidden md:block">
                        <img src="images/0002.jpg" alt="Learning Environment" className="rounded-2xl shadow-2xl"/>
                    </div>
                </div>
            </section>

            <section className="py-20 bg-white">
                <div className="container mx-auto px-4 max-w-7xl">
                    <div className="max-w-5xl mx-auto">
                        <div className="text-center mb-16">
                            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Why Choose SmartMath?</h2>
                        </div>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-16">
                            <div>
                                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                                    <img src="images/0006.jpg"
                                         alt="SmartMath Learning Environment" className="w-full h-56 object-cover"/>
                                    <div className="p-8">
                                        <h3 className="text-xl font-semibold text-gray-900 mb-4">Master Math and
                                            Beyond</h3>
                                        <p className="text-gray-700 mb-6">At SmartMath, we combine traditional teaching
                                            methods with
                                            modern technology to create an engaging and effective learning environment.
                                            Our goal is
                                            to help students truly understand math—not just memorize it.</p>
                                        <p className="text-gray-700 mb-6">Students learn how to apply math concepts to
                                            improve exam
                                            scores and relate them to real-life situations. Our courses are carefully
                                            designed to
                                            guide students up the proficiency ladder while meeting all state-required
                                            standards.</p>
                                        <p className="text-gray-700 mb-6">From foundational math to Algebra, Geometry,
                                            Calculus, and
                                            Statistics, we make sure every student builds a strong foundation before
                                            moving on to
                                            more advanced topics.</p>

                                        <div className="space-y-6">
                                            <div>
                                                <h4 className="font-semibold text-gray-900 mb-2">Our Commitment</h4>
                                                <div className="flex items-start space-x-3">
                                                    <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                                    <p className="text-gray-700">100% placement rate in Advanced &
                                                        Honors
                                                        Math programs</p>
                                                </div>
                                                <div className="flex items-start space-x-3 mt-2">
                                                    <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                                    <p className="text-gray-700">Continuous progress monitoring and
                                                        feedback</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="bg-primary/5 rounded-lg p-8">
                                    <h3 className="text-xl font-semibold text-gray-900 mb-6">Our Programs</h3>
                                    <div className="space-y-6">
                                        <div>
                                            <h4 className="font-medium text-gray-900 mb-3">Math Tutoring (Grades
                                                1-12)</h4>
                                            <p className="text-gray-700">Comprehensive coverage from basic arithmetic to
                                                advanced
                                                calculus & AB/BC, ensuring strong mathematical foundations.</p>
                                        </div>
                                        <div>
                                            <h4 className="font-medium text-gray-900 mb-3">SAT & PSAT Prep</h4>
                                            <p className="text-gray-700">Focused strategies and personalized coaching to
                                                boost test
                                                scores and build confidence for college admissions.</p>
                                        </div>
                                        <div>
                                            <h4 className="font-medium text-gray-900 mb-3">English Tutoring</h4>
                                            <p className="text-gray-700">Build essential reading, writing, and
                                                comprehension skills
                                                through structured learning programs.</p>
                                        </div>
                                    </div>
                                    <div className="mt-8">
                                        <div className="bg-white rounded-lg p-6">
                                            <h4 className="font-medium text-gray-900 mb-4">Program Features</h4>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div className="flex items-center space-x-2">
                                                    <i className="ri-user-star-line text-primary"></i>
                                                    <span className="text-sm text-gray-700">Certified Tutors</span>
                                                </div>
                                                <div className="flex items-center space-x-2">
                                                    <i className="ri-book-open-line text-primary"></i>
                                                    <span
                                                        className="text-sm text-gray-700">Comprehensive Learning</span>
                                                </div>
                                                <div className="flex items-center space-x-2">
                                                    <i className="ri-focus-3-line text-primary"></i>
                                                    <span className="text-sm text-gray-700">Personalized Approach</span>
                                                </div>
                                                <div className="flex items-center space-x-2">
                                                    <i className="ri-medal-line text-primary"></i>
                                                    <span className="text-sm text-gray-700">Proven Results</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>

                                <div className="bg-white rounded-lg shadow-lg p-6 mt-6">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <p className="text-sm text-gray-600">Get Started Today</p>
                                            {/*<p className="text-2xl font-bold text-primary">Contact Us</p>*/}
                                            <a href="#contact" className="text-2xl font-bold text-primary">Contact
                                                Us</a>
                                        </div>
                                        <button onClick={handleEnrollClick}
                                                className="bg-primary text-white px-8 py-3 rounded-button font-semibold hover:bg-primary/90 transition shadow-lg">Enroll
                                            Your Child
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="mission" className="py-20 bg-gradient-to-br from-primary/5 to-white">
                <div className="container mx-auto px-4 max-w-7xl">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                        <div className="order-2 lg:order-1">
                            <h4 className="text-3xl md:text-3xl font-bold text-gray-900 mb-6">
                                Our Mission
                            </h4>
                            <div className="space-y-6">
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 mb-3">Our Belief</h3>
                                    <p className="text-gray-700">At SmartMath, we believe that every student has the
                                        potential to become
                                        proficient in math. While every learner's path may be unique, all students can
                                        significantly
                                        improve their skills with a solid foundation, emotional support, and a
                                        commitment to
                                        growth.</p>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 mb-3">Our Approach</h3>
                                    <div className="bg-primary/5 rounded-lg p-6 space-y-6">
                                        <div className="flex items-start space-x-4">
                                            <div
                                                className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                                <i className="ri-road-map-line text-primary"></i>
                                            </div>
                                            <div>
                                                <h4 className="font-medium text-gray-900 mb-2">Personalized Learning
                                                    Pathways</h4>
                                                <p className="text-gray-700">We recognize that while students follow
                                                    similar
                                                    steppingstones, their journeys are unique. We build clear,
                                                    structured pathways
                                                    tailored to each student's learning style and needs.</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-4">
                                            <div
                                                className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                                <i className="ri-stack-line text-primary"></i>
                                            </div>
                                            <div>
                                                <h4 className="font-medium text-gray-900 mb-2">Comprehensive Skill
                                                    Development</h4>
                                                <p className="text-gray-700">Our programs build a strong foundation,
                                                    ensuring
                                                    proficiency at every level from 4th grade through college.</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-4">
                                            <div
                                                className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                                <i className="ri-mind-map text-primary"></i>
                                            </div>
                                            <div>
                                                <h4 className="font-medium text-gray-900 mb-2">Life-Long Skills</h4>
                                                <p className="text-gray-700">Beyond academics, we view math as a tool to
                                                    enrich life,
                                                    foster logical thinking, boost confidence, and open doors to careers
                                                    in fields
                                                    such as business, physics, and engineering.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 mb-3">The Role of Parents</h3>
                                    <p className="text-gray-700">Parental involvement is vital to student success. We
                                        engage parents
                                        early and keep them informed about their child's progress, key milestones, and
                                        expectations,
                                        fostering a supportive learning environment at home.</p>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 mb-3">Our Purpose</h3>
                                    <p className="text-gray-700">The purpose of SmartMath is to help every student reach
                                        their highest
                                        potential in math. We achieve this by building on their current foundation and
                                        fostering
                                        life skills such as confidence, clear thinking, and resilience. With the
                                        combined efforts of
                                        students, teachers, and parents, we open doors to future academic and
                                        professional
                                        success.</p>
                                </div>
                            </div>
                        </div>
                        <div className="order-1 lg:order-2">
                            <div className="relative rounded-2xl overflow-hidden shadow-xl">
                                <img src="images/0007.jpg" alt="SmartMath Learning Environment"
                                     className="w-full h-full object-cover"/>
                                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="courses" className="py-20">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">Our Courses</h2>
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                        <div className="bg-white p-4 rounded-md shadow-md">
                            <h3 className="text-xl font-bold mb-4">Mathematics</h3>
                            <ul className="space-y-2 text-gray-600">
                                <li><i className="ri-arrow-right-s-line text-primary"></i> Basic Math & Pre-Algebra</li>
                                <li><i className="ri-arrow-right-s-line text-primary"></i> Algebra I & II</li>
                                <li><i className="ri-arrow-right-s-line text-primary"></i> Geometry</li>
                                <li><i className="ri-arrow-right-s-line text-primary"></i> Pre-Calculus & Calculus</li>
                                <li><i className="ri-arrow-right-s-line text-primary"></i> Statistics</li>
                            </ul>
                        </div>
                        <div className="bg-white p-4 rounded-md shadow-md">
                            <h3 className="text-xl font-bold mb-4">English</h3>
                            <ul className="space-y-2 text-gray-600">
                                <li><i className="ri-arrow-right-s-line text-primary"></i> Reading Comprehension</li>
                                <li><i className="ri-arrow-right-s-line text-primary"></i> Writing Skills</li>
                                <li><i className="ri-arrow-right-s-line text-primary"></i> Grammar & Vocabulary</li>
                            </ul>
                        </div>
                        <div className="bg-white p-4 rounded-md shadow-md">
                            <h3 className="text-xl font-bold mb-4">Science</h3>
                            <ul className="space-y-2 text-gray-600">
                                <li><i className="ri-arrow-right-s-line text-primary"></i> Physics</li>
                                <li><i className="ri-arrow-right-s-line text-primary"></i> Chemistry</li>
                                <li><i className="ri-arrow-right-s-line text-primary"></i> Biology</li>
                            </ul>
                        </div>
                        <div className="bg-white p-4 rounded-md shadow-md">
                            <h3 className="text-xl font-bold mb-4">Test Preparation</h3>
                            <ul className="space-y-2 text-gray-600">
                                <li><i className="ri-arrow-right-s-line text-primary"></i> SAT</li>
                                <li><i className="ri-arrow-right-s-line text-primary"></i> ACT</li>
                                <li><i className="ri-arrow-right-s-line text-primary"></i> PSAT</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section id="summer" className="py-20 bg-white">
                <div className="container mx-auto px-4 max-w-7xl">
                    <div className="max-w-5xl mx-auto">
                        <div className="text-center mb-16">
                            <span className="text-primary font-medium mb-4 inline-block">Summer {new Date().getFullYear()}</span>
                            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Geometry Summer
                                Program</h2>
                            <p className="text-lg text-gray-600">Accelerated 5-Credit Course for Advanced Students</p>
                        </div>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-16">
                            <div>
                                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                                    <img src="images/0011.jpg"
                                         alt="Geometry Summer Program" className="w-full h-80 object-cover"/>
                                    <div className="p-8">
                                        <h3 className="text-xl font-semibold text-gray-900 mb-4">Program Overview</h3>
                                        <p className="text-gray-700 mb-6">
                                            Our Advanced Geometry Summer Program offers students an opportunity to
                                            accelerate their
                                            math journey and prepare for future academic success. This intensive program
                                            covers
                                            essential geometry topics and provides the foundation needed for advanced
                                            coursework.
                                        </p>
                                        <div className="space-y-6">
                                            <div>
                                                <h4 className="font-semibold text-gray-900 mb-2">School Prerequisite for
                                                    Enrollment</h4>
                                                <div className="flex items-start space-x-3">
                                                    <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                                    <p className="text-gray-700">Completion of Algebra I with a grade of
                                                        93% or
                                                        higher</p>
                                                </div>
                                            </div>
                                            <div>
                                                <h4 className="font-semibold text-gray-900 mb-2">Success Criteria</h4>
                                                <div className="space-y-2">
                                                    <div className="flex items-start space-x-3">
                                                        <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                                        <p className="text-gray-700">Students must achieve a final grade
                                                            of 85% or
                                                            higher to qualify for advancement.</p>
                                                    </div>
                                                    <div className="flex items-start space-x-3">
                                                        <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                                        <p className="text-gray-700">A final grade of 95% or higher is
                                                            required for
                                                            eligibility in AP-level science courses.</p>
                                                    </div>
                                                </div>
                                                <p>&nbsp;</p>
                                                <p className="flex items-start space-x-3">Prepare in advance to excel in
                                                    the Geometry
                                                    Summer Program and reach your academic goals.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-lg p-6 mt-6">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <p className="text-xl font-bold text-primary">Limited Spots Available</p>
                                        </div>
                                        <button onClick={handleEnrollClick} className="bg-primary text-white px-6 py-2.5 !rounded-button font-medium hover:bg-primary/90 transition whitespace-nowrap">
                                            Enroll Now
                                        </button>
                                    </div>
                                </div>

                            </div>
                            <div>
                                <div className="bg-primary/5 rounded-lg p-8">
                                    <div className="bg-white rounded-lg p-6 mb-8">
                                        <h4 className="font-medium text-gray-900 mb-4">Program Highlights</h4>
                                        <div className="grid grid-cols-2 gap-4">
                                            <div className="flex items-center space-x-2">
                                                <i className="ri-time-line text-primary"></i>
                                                <span className="text-sm text-gray-700">6 Weeks Duration</span>
                                            </div>
                                            <div className="flex items-center space-x-2">
                                                <i className="ri-group-line text-primary"></i>
                                                <span className="text-sm text-gray-700">Small Class Size</span>
                                            </div>
                                            <div className="flex items-center space-x-2">
                                                <i className="ri-book-open-line text-primary"></i>
                                                <span className="text-sm text-gray-700">Daily Practice</span>
                                            </div>
                                            <div className="flex items-center space-x-2">
                                                <i className="ri-medal-line text-primary"></i>
                                                <span className="text-sm text-gray-700">5 Credits</span>
                                            </div>
                                        </div>
                                    </div>
                                    <h3 className="text-l font-semibold text-gray-900 mb-6">Topics Covered</h3>
                                    <div className="space-y-4">
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Basics of Geometry</h4>
                                                <p className="text-sm text-gray-700">Fundamental concepts and
                                                    terminology.</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Reasoning and Proof</h4>
                                                <p className="text-sm text-gray-700">Understanding geometric logic and
                                                    constructing
                                                    proofs.</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Properties of Angles and
                                                    Segments</h4>
                                                <p className="text-sm text-gray-700">Exploring angle relationships and
                                                    segment
                                                    properties.</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Parallel and Perpendicular
                                                    Lines</h4>
                                                <p className="text-sm text-gray-700">Analyzing line relationships and
                                                    their
                                                    properties.</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Triangles</h4>
                                                <p className="text-sm text-gray-700">Congruence, properties, and
                                                    classifications.</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Quadrilaterals</h4>
                                                <p className="text-sm text-gray-700">Types and their
                                                    characteristics. </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Polygons</h4>
                                                <p className="text-sm text-gray-700">Properties and
                                                    classifications. </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Transformations</h4>
                                                <p className="text-sm text-gray-700">Translations, reflections,
                                                    rotations, and
                                                    dilations. </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Similarity</h4>
                                                <p className="text-sm text-gray-700">Similar polygons and
                                                    triangles. </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Right Triangles and
                                                    Trigonometry</h4>
                                                <p className="text-sm text-gray-700">Theorems and trigonometric
                                                    ratios. </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Circles</h4>
                                                <p className="text-sm text-gray-700">Properties, chords, tangents, and
                                                    arcs. </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start space-x-3">
                                            <i className="ri-checkbox-circle-line text-primary mt-1"></i>
                                            <div>
                                                <h4 className="font-small text-gray-900">Area, Surface Area, and
                                                    Volume</h4>
                                                <p className="text-sm text-gray-700">Measuring two-dimensional and
                                                    three-dimensional
                                                    figures. </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="about" className="py-20">
                <div className="container mx-auto px-4 grid md:grid-cols-2 gap-12 items-center">
                    <div className="relative w-full max-w-md mx-auto md:mx-60">
                        <div className="bg-primary/10 rounded-full absolute -top-4 -left-4 w-full h-full"></div>
                        <img src="images/nikita_patel-scaled.jpg" alt="Nikita Patel"
                             className="relative rounded-full shadow-2xl"/>
                    </div>
                    <div>
                        <span className="text-primary font-semibold">Meet Your Educator</span>
                        <h2 className="text-3xl md:text-4xl font-bold my-3">Nikita Patel</h2>
                        <p className="text-gray-600 mb-4">
                            With a Master’s degree in Mathematics and Information Systems, I am dedicated to helping
                            students achieve academic excellence. My experience at the NJIT Pre-College Program has
                            equipped me with the skills to design effective curricula and mentor students to success.
                        </p>

                        <div className="space-y-6">
                            <div>
                                <h3 className="text-xl font-bold text-dark mb-2">Commitment to Student Success</h3>
                                <p className="text-gray-600">I am passionate about helping students achieve top scores
                                    and stay ahead in their academic journey. I track student progress closely,
                                    providing parents with regular updates on achievements, areas for improvement, and
                                    upcoming exams. My personalized approach ensures that students build confidence,
                                    master concepts, and reach their highest potential.</p>
                            </div>
                            <div>
                                <h3 className="text-xl font-bold text-dark mb-2">Guidance for Parents</h3>
                                <p className="text-gray-600 mb-4">I believe that parent involvement is crucial for
                                    student success. I provide detailed guidance to parents on navigating high school
                                    academic pathways, selecting AP courses, and creating strategies for academic
                                    excellence. My goal is to empower both students and parents to make informed
                                    decisions that lead to future success.</p>
                                <ul className="space-y-2 text-gray-600">
                                    <li><i className="ri-checkbox-circle-line text-primary"></i> Regular Progress
                                        Updates
                                    </li>
                                    <li><i className="ri-checkbox-circle-line text-primary"></i> Parent-Teacher Meetings
                                    </li>
                                    <li><i className="ri-checkbox-circle-line text-primary"></i> Customized Learning
                                        Plans
                                    </li>
                                </ul>
                            </div>
                            <p className="text-gray-600">With my experience and commitment, I help students unlock their
                                potential and achieve academic excellence, preparing them for higher education and
                                beyond.</p>
                        </div>

                        {/*<div className="flex space-x-4 mt-6">*/}
                        {/* <a href="#" className="text-gray-500 hover:text-primary transition"><i*/}
                        {/* className="ri-linkedin-box-fill text-2xl"></i></a>*/}
                        {/* <a href="#" className="text-gray-500 hover:text-primary transition"><i*/}
                        {/* className="ri-mail-fill text-2xl"></i></a>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </section>
        </div>
    );
};


// --- UPDATED: Header Component ---
// --- UPDATED: Header Component ---
const Header = ({setCurrentPage, isLoggedIn, onLogout}) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleNavClick = (e, targetId) => {
        e.preventDefault();
        setCurrentPage('landing');
        setIsMobileMenuOpen(false); // Close mobile menu on nav click
        setTimeout(() => {
            const element = document.querySelector(targetId);
            if (element) {
                element.scrollIntoView({behavior: 'smooth'});
            }
        }, 0);
    };

    return (
        <header className="sticky top-0 z-50 bg-white shadow-sm">
            <div className="container mx-auto px-4 py-4 flex items-center justify-between">
                <a href="#home" onClick={(e) => handleNavClick(e, '#home')} className="flex items-center space-x-2">
                    {/*<img src="images/Logo.svg" alt="SmartMath"/>*/}
                    <img src="images/logo-main.svg" alt="SmartMath"/>
                    {/*<img src="images/LinkedinCover" alt="SmartMath"/>*/}
                </a>
                {/* Desktop Nav */}
                <nav className="hidden md:flex items-center space-x-6">
                    <a href="#home" onClick={(e) => handleNavClick(e, '#home')}
                       className="text-gray-600 hover:text-primary transition">Home</a>
                    <a href="#mission" onClick={(e) => handleNavClick(e, '#mission')}
                       className="text-gray-600 hover:text-primary transition">Mission</a>
                    <a href="#courses" onClick={(e) => handleNavClick(e, '#courses')}
                       className="text-gray-600 hover:text-primary transition">Courses</a>
                    <a href="#summer" onClick={(e) => handleNavClick(e, '#summer')}
                       className="text-gray-600 hover:text-primary transition">Summer</a>
                    <a href="#about" onClick={(e) => handleNavClick(e, '#about')}
                       className="text-gray-600 hover:text-primary transition">About</a>
                    <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')}
                       className="text-gray-600 hover:text-primary transition">Contact</a>
                </nav>
                <div className="flex items-center space-x-4">
                    {isLoggedIn ? (
                        <>
                            <button onClick={() => setCurrentPage('profile')}
                                    className="hidden md:inline-block bg-primary text-white py-2 px-4 rounded-button font-medium hover:bg-blue-700 transition-colors !rounded-button whitespace-nowrap">Dashboard
                            </button>
                            <button onClick={onLogout}
                                    className="hidden md:inline-block bg-gray-200 text-gray-800 py-2 px-4 rounded-button font-medium hover:bg-gray-300 transition-colors !rounded-button whitespace-nowrap">Logout
                            </button>
                        </>
                    ) : (
                        <>
                            <button onClick={() => setCurrentPage('login')}
                                    className="hidden md:inline-block bg-gray-200 text-gray-800 py-2 px-4 rounded-button font-medium hover:bg-gray-300 transition-colors !rounded-button whitespace-nowrap">Login
                            </button>
                            <button onClick={() => setCurrentPage('registration')}
                                    className="hidden md:inline-block bg-primary text-white py-2 px-4 rounded-button font-medium hover:bg-blue-700 transition-colors !rounded-button whitespace-nowrap">Enroll
                                Now
                            </button>
                        </>
                    )}
                    {/* Mobile Menu Button */}
                    <button className="md:hidden text-2xl" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                        <i className={isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"}></i>
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-md">
                    <nav className="flex flex-col items-center space-y-4 p-4">
                        <a href="#home" onClick={(e) => handleNavClick(e, '#home')}
                           className="text-gray-600 hover:text-primary transition">Home</a>
                        <a href="#mission" onClick={(e) => handleNavClick(e, '#mission')}
                           className="text-gray-600 hover:text-primary transition">Mission</a>
                        <a href="#courses" onClick={(e) => handleNavClick(e, '#courses')}
                           className="text-gray-600 hover:text-primary transition">Courses</a>
                        <a href="#summer" onClick={(e) => handleNavClick(e, '#summer')}
                           className="text-gray-600 hover:text-primary transition">Summer</a>
                        <a href="#about" onClick={(e) => handleNavClick(e, '#about')}
                           className="text-gray-600 hover:text-primary transition">About</a>
                        <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')}
                           className="text-gray-600 hover:text-primary transition">Contact</a>
                        <div className="border-t w-full my-2"></div>
                        {isLoggedIn ? (
                            <>
                                <button onClick={() => {
                                    setCurrentPage('profile');
                                    setIsMobileMenuOpen(false);
                                }}
                                        className="w-full bg-primary text-white py-2 px-4 rounded-button font-medium hover:bg-blue-700 transition-colors">Dashboard
                                </button>
                                <button onClick={() => {
                                    onLogout();
                                    setIsMobileMenuOpen(false);
                                }}
                                        className="w-full bg-gray-200 text-gray-800 py-2 px-4 rounded-button font-medium hover:bg-gray-300 transition-colors">Logout
                                </button>
                            </>
                        ) : (
                            <>
                                <button onClick={() => {
                                    setCurrentPage('login');
                                    setIsMobileMenuOpen(false);
                                }}
                                        className="w-full bg-gray-200 text-gray-800 py-2 px-4 rounded-button font-medium hover:bg-gray-300 transition-colors">Login
                                </button>
                                <button onClick={() => {
                                    setCurrentPage('registration');
                                    setIsMobileMenuOpen(false);
                                }}
                                        className="w-full bg-primary text-white py-2 px-4 rounded-button font-medium hover:bg-blue-700 transition-colors">Enroll
                                    Now
                                </button>
                            </>
                        )}
                    </nav>
                </div>
            )}
        </header>
    );
};

// --- NEW: Terms and Conditions Modal ---
const TermsModal = ({onClose}) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
                <h2 className="text-2xl font-bold mb-4">Terms and Conditions</h2>
                <div className="space-y-4 text-gray-700">
                    <div>
                        <h3 className="font-semibold">1. Service Agreement</h3>
                        <p>By registering, you agree to enroll your child in the selected tutoring programs. Services
                            are provided on a best-effort basis to support your child's academic goals.</p>
                    </div>
                    <div>
                        <h3 className="font-semibold">2. Payment Terms</h3>
                        <p>Tuition fees are due monthly and will be automatically charged to the payment method on file.
                            A security deposit is required upon enrollment and will be applied to the final month's
                            tuition upon 30 days' written notice of withdrawal. A <strong>3% processing fee</strong> will be added to all credit card payments.</p>
                    </div>
                    <div>
                        <h3 className="font-semibold">3. Cancellation Policy</h3>
                        <p>A 30-day written notice is required for withdrawal from any program. Failure to provide
                            notice will result in the forfeiture of the security deposit.</p>
                    </div>
                    <div>
                        <h3 className="font-semibold">4. Privacy Policy</h3>
                        <p>We are committed to protecting your privacy. Your personal information will be used solely
                            for administrative and communication purposes and will not be shared with third parties.</p>
                    </div>
                </div>
                <div className="text-right mt-6">
                    <button onClick={onClose}
                            className="bg-primary text-white px-6 py-2 rounded-button font-medium hover:bg-primary/90 transition">Close
                    </button>
                </div>
            </div>
        </div>
    );
};


// Registration Page Component
const RegistrationPage = ({setCurrentPage, locations}) => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        locationId: '' // Initialize as empty
    });
    const [error, setError] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [showTermsModal, setShowTermsModal] = useState(false);


    useEffect(() => {
        if (locations.length > 0 && !formData.locationId) {
            setFormData(prev => ({...prev, locationId: locations[0].locationId}));
        }
    }, [locations, formData.locationId]);


    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData(prev => ({...prev, [name]: value}));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (formData.password !== formData.confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/auth/register`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    email: formData.email,
                    phone: formData.phone,
                    password: formData.password,
                    locationId: formData.locationId
                })
            });

            if (response.ok) {
                console.log('Registration successful');
                setCurrentPage('login');
            } else {
                const errorData = await response.json();
                setError(errorData.message || 'Registration failed. Please try again.');
            }
        } catch (err) {
            console.error("Registration failed:", err);
            setError('An error occurred during registration. Please check the console.');
        }
    };

    return (
        <>
            {showTermsModal && <TermsModal onClose={() => setShowTermsModal(false)}/>}
            <div className="bg-white rounded-xl shadow-lg p-8">

                <div className="flex items-center mb-6">
                    <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                        <i className="ri-user-add-line text-primary text-xl"></i>
                    </div>
                    <div>
                        <div className="flex items-center space-x-3">
                            <h3 className="text-1xl font-bold text-gray-900">Parent Registration</h3>
                        </div>
                        <p className="text-gray-600">Join our academic excellence community</p>
                    </div>
                </div>
                <div className="text-center mb-8">
                    <div className="text-center mb-8">
                        <div className="max-w-lg mx-auto p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-800 text-center">
                            <p><i className="ri-information-line align-middle mr-1"></i>* After registering, you can enroll your child from the Parent Dashboard.</p>
                        </div>
                    </div>

                </div>

                {/*
                    <div className="flex items-center mb-6">
                            <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                                <i className="ri-user-add-line text-primary text-xl"></i>
                            </div>
                        <div>
                            <div className="flex items-center space-x-3">
                                <h3 className="text-1xl font-bold text-gray-900">Create Parent Account</h3>
                            </div>
                            <p className="text-gray-600">Join our academic excellence community</p>
                            <p className="text-gray-600">* After registering, you can enroll your child from the Parent Dashboard.</p>
                        </div>
                    </div>
                */}
                <form className="space-y-6 max-w-md mx-auto" onSubmit={handleSubmit}>
                    {error && <div className="bg-red-100 text-red-700 p-3 rounded-lg text-center">{error}</div>}
                    <div className="grid grid-cols-2 gap-4 mb-6">
                        <div>
                            <label htmlFor="reg-firstName" className="block text-sm font-medium text-gray-700 mb-2">First
                                Name</label>
                            <input type="text" id="reg-firstName" name="firstName" value={formData.firstName}
                                   onChange={handleChange}
                                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                                   placeholder="Parent first name" required/>
                        </div>
                        <div>
                            <label htmlFor="reg-lastName" className="block text-sm font-medium text-gray-700 mb-2">Last
                                Name</label>
                            <input type="text" id="reg-lastName" name="lastName" value={formData.lastName}
                                   onChange={handleChange}
                                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                                   placeholder="Parent last name" required/>
                        </div>
                    </div>

                    <div>
                        <label htmlFor="location"
                               className="block text-sm font-medium text-gray-700 mb-2">Location</label>
                        <select
                            id="location"
                            name="locationId"
                            value={formData.locationId}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                        >
                            {locations.map(loc => (
                                <option key={loc.locationId} value={loc.locationId}>{loc.name}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label htmlFor="reg-email"
                               className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                        <input type="email" id="reg-email" name="email" value={formData.email} onChange={handleChange}
                               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                               placeholder="Parent email address" required/>
                    </div>
                    <div>
                        <label htmlFor="reg-phone"
                               className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                        <input type="tel" id="reg-phone" name="phone" value={formData.phone} onChange={handleChange}
                               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                               placeholder="Parent phone number"/>
                    </div>
                    <div>
                        <label htmlFor="reg-password"
                               className="block text-sm font-medium text-gray-700 mb-2">Password</label>
                        <input type="password" id="reg-password" name="password" value={formData.password} onChange={handleChange}
                               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                               placeholder="Create a strong password" required/>
                    </div>
                    <div>
                        <label htmlFor="reg-confirmPassword" className="block text-sm font-medium text-gray-700 mb-2">Confirm Password</label>
                        <input type="password" id="reg-confirmPassword" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange}
                               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                               placeholder="Confirm password" required/>
                    </div>
                    <div className="flex items-center">
                        <input
                            id="terms-checkbox"
                            type="checkbox"
                            checked={termsAccepted}
                            onChange={(e) => setTermsAccepted(e.target.checked)}
                            className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
                        />
                        <label htmlFor="terms-checkbox" className="ml-2 block text-sm text-gray-900">
                            I agree to the{" "}
                            <button type="button" onClick={() => setShowTermsModal(true)} className="text-primary hover:underline font-medium">
                                Terms and Conditions
                            </button>
                        </label>
                    </div>
                    <button type="submit"
                            disabled={!termsAccepted}
                            className="w-full bg-primary text-white py-3 px-6 rounded-button font-medium hover:bg-blue-700 transition-colors !rounded-button whitespace-nowrap disabled:bg-gray-400 disabled:cursor-not-allowed">
                        Sign Up
                    </button>
                    <p className="text-center text-sm text-gray-600">
                        Already have an account?
                        <button type="button" className="text-primary hover:underline ml-1" onClick={() => setCurrentPage('login')}>Login here</button>
                    </p>
                </form>
            </div>
        </>
    );
};

// Login Page Component
const LoginPage = ({ setCurrentPage, onLogin }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: formData.email, password: formData.password })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.userRole === 'PARENT') {
                    onLogin(data);
                } else {
                    setError('Access denied. This portal is for parents only.');
                }
            } else {
                setError('Login failed. Please check your credentials.');
            }
        } catch (err) {
            console.error("Login failed:", err);
            setError('An error occurred during login. Please try again.');
        }
    };

    return (
        <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-login-circle-line text-primary text-xl"></i>
                </div>
                <h2 className="text-2xl font-bold text-gray-900">Login</h2>
            </div>
            <div className="text-center mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">Welcome Back</h1>
                <p className="text-gray-600">Sign in to your parent portal</p>
            </div>
            <form className="space-y-6 max-w-md mx-auto" onSubmit={handleSubmit}>
                {error && <div className="bg-red-100 text-red-700 p-3 rounded-lg text-center">{error}</div>}
                <div>
                    <label htmlFor="login-username" className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                    <input type="email" id="login-username" name="email" value={formData.email} onChange={handleChange}
                           className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                           placeholder="Enter your email" required/>
                </div>
                <div>
                    <label htmlFor="login-password" className="block text-sm font-medium text-gray-700 mb-2">Password</label>
                    <input type="password" id="login-password" name="password" value={formData.password} onChange={handleChange}
                           className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                           placeholder="Enter your password" required/>
                </div>

                <button type="submit"
                        className="w-full bg-primary text-white py-3 px-6 rounded-button font-medium hover:bg-blue-700 transition-colors !rounded-button whitespace-nowrap">
                    Login
                </button>

                <div className="text-center text-sm text-gray-600 space-y-2">
                    <p>
                        Don't have an account?
                        <button type="button" className="text-primary hover:underline ml-1" onClick={() => setCurrentPage('registration')}>
                            Sign up here
                        </button>
                    </p>
                    <p>
                        <button type="button" className="text-primary hover:underline" onClick={() => setCurrentPage('forgotPassword')}>
                            Forgot password?
                        </button>
                    </p>
                </div>
            </form>
        </div>
    );
};

// New ForgotPasswordPage Component
const ForgotPasswordPage = ({ setCurrentPage, setEmailForReset }) => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setIsError(false);

        try {
            await apiFetch('/auth/forgot-password', {
                method: 'POST',
                body: JSON.stringify({ email })
            });
            setEmailForReset(email);
            setCurrentPage('resetPassword');
        } catch (err) {
            setMessage(err.message || 'An error occurred. Please try again later.');
            setIsError(true);
        }
    };

    return (
        <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-lock-unlock-line text-primary text-xl"></i>
                </div>
                <h2 className="text-2xl font-bold text-gray-900">Forgot Password</h2>
            </div>
            <div className="text-center mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">Reset Your Password</h1>
                <p className="text-gray-600">Enter your email to receive a temporary password on your phone.</p>
            </div>
            <form className="space-y-6 max-w-md mx-auto" onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="forgot-email" className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
                    <input type="email" id="forgot-email" name="email" value={email} onChange={(e) => setEmail(e.target.value)}
                           className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                           placeholder="Enter your email address" required />
                </div>
                {message && (
                    <div className={`px-4 py-2 rounded-lg text-sm ${isError ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                        {message}
                    </div>
                )}
                <button type="submit"
                        className="w-full bg-primary text-white py-3 px-6 rounded-button font-medium hover:bg-blue-700 transition-colors !rounded-button whitespace-nowrap">Reset Password
                </button>
                <p className="text-center text-sm text-gray-600">
                    Remember your password?
                    <button type="button" className="text-primary hover:underline ml-1" onClick={() => setCurrentPage('login')}>Login here</button>
                </p>
            </form>
        </div>
    );
};

// New ResetPasswordPage Component
const ResetPasswordPage = ({ setCurrentPage, email, onLogin }) => {
    const [formData, setFormData] = useState({
        tempPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (formData.newPassword !== formData.confirmPassword) {
            setError("New passwords do not match.");
            return;
        }

        try {
            const response = await apiFetch('/auth/reset-password', {
                method: 'POST',
                body: JSON.stringify({
                    email,
                    tempPassword: formData.tempPassword,
                    newPassword: formData.newPassword,
                    confirmPassword: formData.confirmPassword
                })
            });
            onLogin(response); // Automatically log the user in
        } catch (err) {
            setError(err.message || 'Failed to reset password. Please check the temporary password and try again.');
        }
    };

    return (
        <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-key-2-line text-primary text-xl"></i>
                </div>
                <h2 className="text-2xl font-bold text-gray-900">Set New Password</h2>
            </div>
            <div className="text-center mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">Complete Password Reset</h1>
                <p className="text-gray-600">A temporary password was sent to your phone for {email}.</p>
            </div>
            <form className="space-y-6 max-w-md mx-auto" onSubmit={handleSubmit}>
                {error && <div className="bg-red-100 text-red-700 p-3 rounded-lg text-center">{error}</div>}
                <div>
                    <label htmlFor="temp-password" className="block text-sm font-medium text-gray-700 mb-2">Temporary Password</label>
                    <input type="password" id="temp-password" name="tempPassword" value={formData.tempPassword} onChange={handleChange}
                           className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                           placeholder="Enter temporary password" required />
                </div>
                <div>
                    <label htmlFor="new-password" className="block text-sm font-medium text-gray-700 mb-2">New Password</label>
                    <input type="password" id="new-password" name="newPassword" value={formData.newPassword} onChange={handleChange}
                           className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                           placeholder="Enter new password" required />
                </div>
                <div>
                    <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700 mb-2">Confirm New Password</label>
                    <input type="password" id="confirm-password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange}
                           className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                           placeholder="Confirm new password" required />
                </div>
                <button type="submit"
                        className="w-full bg-primary text-white py-3 px-6 rounded-button font-medium hover:bg-blue-700 transition-colors !rounded-button whitespace-nowrap">
                    Set New Password and Login
                </button>
            </form>
        </div>
    );
};


// Personal Profile Page Component
const PersonalProfilePage = ({ setCurrentPage, authData, userProfile, onDataRefresh, setStudentForEnrollment }) => {
    const profileData = userProfile;

    const [isEditingProfile, setIsEditingProfile] = useState(false);
    const [editedProfileData, setEditedProfileData] = useState(null);

    const [childrenData, setChildrenData] = useState([]);
    const [editingChildId, setEditingChildId] = useState(null);
    const [editedChildData, setEditedChildData] = useState(null);
    const [childUpdateMessage, setChildUpdateMessage] = useState({ text: '', type: '' });
    const [pendingRequests, setPendingRequests] = useState({});
    const [pendingStudentNames, setPendingStudentNames] = useState(new Set());


    const [paymentHistory, setPaymentHistory] = useState([]);
    const [showAllPayments, setShowAllPayments] = useState(false);
    const paymentHistoryRef = useRef(null);

    const [batches, setBatches] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [locations, setLocations] = useState([]);
    const [paymentMethodDetails, setPaymentMethodDetails] = useState(null);
    const [depositOverview, setDepositOverview] = useState([]);
    const [lastMonthPayments, setLastMonthPayments] = useState([]);


    const fetchDashboardData = async () => {
        if (!authData?.token) return;
        try {
            const [childrenRes, historyRes, batchesRes, subjectsRes, locationsRes, paymentMethodRes, pendingReqRes, depositsRes, lastMonthPaymentsRes] = await Promise.all([
                apiFetch(`/users/${authData.userId}/students`, {}, authData.token),
                apiFetch(`/payments/history/${authData.userId}`, {}, authData.token),
                apiFetch(`/admin/batches?locationId=${authData.locationId}`, {}, authData.token),
                apiFetch('/admin/subjects', {}, authData.token),
                apiFetch('/enrollment/locations', {}, authData.token),
                apiFetch(`/users/${authData.userId}/payment-method`, {}, authData.token).catch(err => {
                    if (err.message.includes('404')) return null;
                    throw err;
                }),
                apiFetch(`/students/pending-requests/${authData.userId}`, {}, authData.token),
                apiFetch(`/users/${authData.userId}/deposits`, {}, authData.token),
                apiFetch(`/users/${authData.userId}/last-month-payments`, {}, authData.token)
            ]);

            const childrenWithAttendance = (childrenRes || []).map(child => ({
                ...child,
                attendance: (child.attendance || []).map(att => ({
                    date: new Date(att.classDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }),
                    present: att.present
                }))
            })).sort((a, b) => {
                const nameA = `${a.firstName} ${a.lastName}`.toLowerCase();
                const nameB = `${b.firstName} ${b.lastName}`.toLowerCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            });

            setChildrenData(childrenWithAttendance);
            setPaymentHistory(historyRes || []);
            setBatches(batchesRes || []);
            setSubjects(subjectsRes || []);
            setLocations(locationsRes || []);
            setPaymentMethodDetails(paymentMethodRes);
            setDepositOverview(depositsRes || []);
            setLastMonthPayments(lastMonthPaymentsRes || []);

            const pendingMap = (pendingReqRes || []).reduce((acc, req) => {
                const student = childrenRes.find(c => `${c.firstName} ${c.lastName}` === req.studentName);
                if (student) {
                    acc[student.studentId] = req.hasPendingRequest;
                }
                return acc;
            }, {});
            setPendingRequests(pendingMap);
            setPendingStudentNames(new Set((pendingReqRes || []).filter(r => r.hasPendingRequest).map(r => r.studentName)));

        } catch (err) {
            console.error("Failed to fetch dashboard data:", err);
        }
    };


    useEffect(() => {
        fetchDashboardData();
    }, [authData, userProfile]); // Re-fetch when userProfile is updated from parent

    const formatInvoiceMonth = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const options = { month: 'long', year: '2-digit', timeZone: 'UTC' };
        return date.toLocaleDateString('en-US', options);
    };

    const grades = ['Kindergarten', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'];
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const reverseDayMap = { MONDAY: 'Mon', TUESDAY: 'Tue', WEDNESDAY: 'Wed', THURSDAY: 'Thu', FRIDAY: 'Fri', SATURDAY: 'Sat', SUNDAY: 'Sun' };


    const isWeekend = (day) => ['Sat', 'Sun'].includes(day);

    const getTimeOptions = (day, studentFirstName, studentLastName, currentEnrollmentId) => {
        const fullDay = Object.keys(reverseDayMap).find(key => reverseDayMap[key] === day);
        if (!fullDay) return [];

        const allTimesForDay = batches
            .filter(b => b.dayOfWeek.toUpperCase() === fullDay)
            .map(b => b.timeSlot)
            .sort();

        const studentEnrollments = childrenData.filter(c =>
            c.firstName === studentFirstName &&
            c.lastName === studentLastName &&
            c.enrollmentId !== currentEnrollmentId
        );

        const existingTimesOnDay = studentEnrollments.flatMap(e => {
            const times = [];
            if (e.day1 === fullDay) times.push(e.day1Time);
            if (e.day2 === fullDay) times.push(e.day2Time);
            return times;
        });

        return allTimesForDay.filter(time => !existingTimesOnDay.includes(time));
    };


    // Profile Edit Handlers
    const handleProfileInputChange = (e) => {
        const { name, value } = e.target;
        setEditedProfileData(prev => ({ ...prev, [name]: value }));
    };

    const handleEditProfile = () => {
        setIsEditingProfile(true);
        setEditedProfileData(profileData);
    };

    const handleSaveProfile = async () => {
        try {
            await apiFetch(`/users/${authData.userId}`, {
                method: 'PUT',
                body: JSON.stringify(editedProfileData),
            }, authData.token);
            onDataRefresh();
            setIsEditingProfile(false);
        } catch (error) {
            console.error('Failed to save profile:', error);
        }
    };

    const handleCancelProfileEdit = () => {
        setIsEditingProfile(false);
        setEditedProfileData(profileData);
    };

    // Child Edit Handlers
    const handleEditChildClick = (child) => {
        setEditingChildId(child.studentId);
        const childWithShortDays = {
            ...child,
            day1: reverseDayMap[child.day1],
            day2: reverseDayMap[child.day2]
        };
        setEditedChildData(childWithShortDays);
    };

    const handleChildChange = (e) => {
        const { name, value } = e.target;
        setEditedChildData(prev => {
            const newState = { ...prev, [name]: value };
            if (name === 'day1' && !getTimeOptions(value, newState.firstName, newState.lastName, newState.enrollmentId).includes(newState.day1Time)) {
                newState.day1Time = getTimeOptions(value, newState.firstName, newState.lastName, newState.enrollmentId)[0] || '';
            }
            if (name === 'day2' && !getTimeOptions(value, newState.firstName, newState.lastName, newState.enrollmentId).includes(newState.day2Time)) {
                newState.day2Time = getTimeOptions(value, newState.firstName, newState.lastName, newState.enrollmentId)[0] || '';
            }
            return newState;
        });
    };

    const handleSaveChild = async () => {
        const dayMapToLong = { Mon: 'MONDAY', Tue: 'TUESDAY', Wed: 'WEDNESDAY', Thu: 'THURSDAY', Fri: 'FRIDAY', Sat: 'SATURDAY', Sun: 'SUNDAY' };
        const findBatchId = (day, time) => {
            const fullDay = dayMapToLong[day];
            const batch = batches.find(b => b.dayOfWeek.toUpperCase() === fullDay && b.timeSlot === time);
            return batch ? batch.batchId : null;
        };

        const newSubject = subjects.find(s => s.name === editedChildData.subject);

        const requestBody = {
            enrollmentId: editedChildData.enrollmentId,
            newSubjectId: newSubject.subjectId,
            newBatchIds: [findBatchId(editedChildData.day1, editedChildData.day1Time), findBatchId(editedChildData.day2, editedChildData.day2Time)].filter(Boolean)
        };

        try {
            if (editedChildData.status === 'ACTIVE') {
                await apiFetch('/students/change-request', {
                    method: 'POST',
                    body: JSON.stringify(requestBody)
                }, authData.token);
                setChildUpdateMessage({ text: 'Change request submitted for approval!', type: 'success' });
            } else if (editedChildData.status === 'NEW_ENROLLMENT') {
                const updatePayload = {
                    ...editedChildData,
                    day1: dayMapToLong[editedChildData.day1],
                    day2: dayMapToLong[editedChildData.day2],
                    parentUserId: authData.userId
                };
                await apiFetch(`/students/${editingChildId}`, {
                    method: 'PUT',
                    body: JSON.stringify(updatePayload),
                }, authData.token);
                setChildUpdateMessage({ text: 'Child enrollment updated successfully!', type: 'success' });
            }

            // Refresh data after any action
            await fetchDashboardData();

            setEditingChildId(null);
            setEditedChildData(null);
            setTimeout(() => setChildUpdateMessage({ text: '', type: '' }), 3000);

        } catch (error) {
            console.error('Failed to save child enrollment:', error);
            setChildUpdateMessage({ text: 'Failed to save changes. Please try again.', type: 'error' });
            setTimeout(() => setChildUpdateMessage({ text: '', type: '' }), 3000);
        }
    };

    const handleCancelChildEdit = () => {
        setEditingChildId(null);
        setEditedChildData(null);
    };

    const handleNewSubjectClick = (clickedChild) => {
        const allEnrollmentsForStudent = childrenData.filter(c => c.studentId === clickedChild.studentId);
        const studentObject = {
            studentId: clickedChild.studentId,
            firstName: clickedChild.firstName,
            lastName: clickedChild.lastName,
            enrollments: allEnrollmentsForStudent.map(e => ({
                subject: e.subject,
                day1: e.day1,
                day1Time: e.day1Time,
                day2: e.day2,
                day2Time: e.day2Time,
                grade: e.grade,
            }))
        };
        setStudentForEnrollment(studentObject);
        setCurrentPage('enrollment');
    };

    const getLocationName = (locationId) => {
        const location = locations.find(loc => loc.locationId === locationId);
        return location ? location.name : 'N/A';
    };

    const getDepositStatusChip = (status) => {
        switch (status) {
            case 'PAID': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">PAID</span>;
            case 'APPLIED': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">APPLIED</span>;
            case 'PAYMENT_INITIATED': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">PAYMENT_INITIATED</span>;
            default: return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">UNPAID</span>;
        }
    };

    const getPaymentStatusChip = (status) => {
        switch (status) {
            case 'PAID': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">PAID</span>;
            case 'FAILED': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">FAILED</span>;
            case 'PENDING': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-red-800">PENDING</span>;
            case 'PAYMENT_INITIATED': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-red-800">PAYMENT_INITIATED</span>;
            default: return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">{status}</span>;
        }
    };

    const getAmountPaymentStatusChip = (status, amount) => {
        switch (status) {
            // case 'PAID': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">PAID</span>;
            // case 'FAILED': return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">FAILED</span>;
            case 'PENDING': return <span className="font-medium text-red-500">${amount}</span>;
            default: return <span className="font-medium text-gray-900">${amount}</span>;
        }
    };


    const handlePayDeposit = async (studentId) => {
        if (!studentId) return;

        if (window.confirm(`Are you sure you want to pay the deposit for this student?`)) {
            try {
                await apiFetch(`/users/deposits/pay/${studentId}`, { method: 'POST' }, authData.token);
                alert('Deposit payment successful!');
                fetchDashboardData(); // Refresh data
            } catch (err) {
                alert(`Deposit payment failed: ${err.message}`);
            }
        }
    };

    const groupedDeposits = useMemo(() => {
        return depositOverview.reduce((acc, deposit) => {
            (acc[deposit.studentName] = acc[deposit.studentName] || []).push(deposit);
            return acc;
        }, {});
    }, [depositOverview]);

    const groupedLastMonthPayments = useMemo(() => {
        return lastMonthPayments.reduce((acc, payment) => {
            (acc[payment.studentName] = acc[payment.studentName] || []).push(payment);
            return acc;
        }, {});
    }, [lastMonthPayments]);

    if (!profileData) {
        return <div className="text-center py-10">Loading profile data...</div>;
    }

    const renderedStudentIds = new Set();

    return (
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="bg-gray-50 p-6 border-b border-gray-200 flex items-center">
                <div className="flex items-center space-x-4">
                    <div className="w-20 h-20 bg-white rounded-full border-2 border-gray-200 shadow-sm flex items-center justify-center">
                        <i className="ri-user-line text-3xl text-gray-400"></i>
                    </div>
                    <div>
                        <div className="flex items-center space-x-3">
                            <h2 className="text-2xl font-bold text-gray-900">{profileData.firstName} {profileData.lastName}</h2>
                            {!isEditingProfile && (
                                <button
                                    onClick={handleEditProfile}
                                    className="p-2 rounded-full bg-blue-100 text-primary hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                                    title="Edit Profile"
                                >
                                    <i className="ri-edit-line text-lg"></i>
                                </button>
                            )}
                        </div>
                        <p className="text-sm text-gray-500">Parent Dashboard</p>
                    </div>
                </div>
            </div>

            <div className="p-10">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    <div className="lg:col-span-2 space-y-8">
                        {isEditingProfile && (
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-4">Edit Profile Information</h3>
                                <div className="grid grid-cols-2 gap-6">
                                    <div>
                                        <label htmlFor="profile-email" className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                                        <input type="email"  id="profile-email" name="email" value={editedProfileData.email} onChange={handleProfileInputChange}
                                               className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-900" />
                                    </div>
                                    <div>
                                        <label htmlFor="profile-phone" className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                                        <input type="tel"  id="profile-phone" name="phone" value={editedProfileData.phone} onChange={handleProfileInputChange}
                                               className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-900" />
                                    </div>
                                </div>
                                <div className="flex justify-end space-x-4 mt-6">
                                    <button
                                        onClick={handleCancelProfileEdit}
                                        className="px-6 py-2 border border-gray-300 text-gray-700 rounded-button font-medium hover:bg-gray-50 transition-colors whitespace-nowrap"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleSaveProfile}
                                        className="px-6 py-2 bg-primary text-white rounded-button font-medium hover:bg-primary/90 transition-colors whitespace-nowrap"
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        )}
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">
                                Enrolled Children
                                <span className="text-sm text-gray-500 font-normal ml-2">
                                    (@ {getLocationName(profileData.locationId)})
                                </span>
                            </h3>
                            {childUpdateMessage.text && (
                                <div className={`p-2 mb-4 text-sm rounded-lg ${childUpdateMessage.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                    {childUpdateMessage.text}
                                </div>
                            )}
                            <div className="space-y-4">
                                {childrenData.map((child) => {
                                    const studentNameKey = `${child.firstName}-${child.lastName}`;
                                    const showName = !renderedStudentIds.has(studentNameKey);
                                    if (showName) {
                                        renderedStudentIds.add(studentNameKey);
                                    }
                                    const hasPending = pendingStudentNames.has(`${child.firstName} ${child.lastName}`);
                                    return (
                                        <div key={`${child.studentId}-${child.subject}`} className="bg-gray-50 rounded-lg overflow-hidden">
                                            <div className="flex items-center justify-between p-4">
                                                <div>
                                                    {showName && <h4 className="font-medium text-gray-900">{child.firstName} {child.lastName} &nbsp;&nbsp; { showName && <button
                                                        onClick={() => handleNewSubjectClick(child)}
                                                        className="p-1 rounded-full bg-gray-100 text-sm text-green-700 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                                        title="Enroll in New Subject"
                                                    >
                                                        {/*<i className="ri-add-line text-lg"></i>*/}
                                                        <i className="ri-add-circle-line mr-1 text-sm" ></i>New Subject
                                                    </button>}
                                                    </h4>}
                                                    {editingChildId === child.studentId ? (
                                                        <div className="flex flex-col space-y-2 mt-2">
                                                            <select
                                                                name="grade"
                                                                value={editedChildData?.grade || ''}
                                                                onChange={handleChildChange}
                                                                className="w-full border border-gray-300 rounded-md px-2 py-1 text-sm focus:ring-primary focus:border-primary"
                                                            >
                                                                {grades.map(grade => (
                                                                    <option key={grade} value={grade}>{grade}</option>
                                                                ))}
                                                            </select>
                                                            <select
                                                                name="subject"
                                                                value={editedChildData?.subject || ''}
                                                                onChange={handleChildChange}
                                                                className="w-full border border-gray-300 rounded-md px-2 py-1 text-sm focus:ring-primary focus:border-primary"
                                                            >
                                                                {subjects.map(subject => (
                                                                    <option key={subject.subjectId} value={subject.name}>{subject.name}</option>
                                                                ))}
                                                            </select>
                                                            <div className="grid grid-cols-2 gap-2">
                                                                <select
                                                                    name="day1"
                                                                    value={editedChildData?.day1 || ''}
                                                                    onChange={handleChildChange}
                                                                    className="w-full border border-gray-300 rounded-md px-2 py-1 text-sm focus:ring-primary focus:border-primary"
                                                                >
                                                                    {daysOfWeek.map(day => (
                                                                        <option key={day} value={day} disabled={day === editedChildData?.day2}>{day}</option>
                                                                    ))}
                                                                </select>
                                                                <select
                                                                    name="day1Time"
                                                                    value={editedChildData?.day1Time || ''}
                                                                    onChange={handleChildChange}
                                                                    className="w-full border border-gray-300 rounded-md px-2 py-1 text-sm focus:ring-primary focus:border-primary"
                                                                >
                                                                    {getTimeOptions(editedChildData?.day1, child.firstName, child.lastName, child.enrollmentId).map(time => (
                                                                        <option key={time} value={time}>{time}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="grid grid-cols-2 gap-2">
                                                                <select
                                                                    name="day2"
                                                                    value={editedChildData?.day2 || ''}
                                                                    onChange={handleChildChange}
                                                                    className="w-full border border-gray-300 rounded-md px-2 py-1 text-sm focus:ring-primary focus:border-primary"
                                                                >
                                                                    {daysOfWeek.map(day => (
                                                                        <option key={day} value={day} disabled={day === editedChildData?.day1}>{day}</option>
                                                                    ))}
                                                                </select>
                                                                <select
                                                                    name="day2Time"
                                                                    value={editedChildData?.day2Time || ''}
                                                                    onChange={handleChildChange}
                                                                    className="w-full border border-gray-300 rounded-md px-2 py-1 text-sm focus:ring-primary focus:border-primary"
                                                                >
                                                                    {getTimeOptions(editedChildData?.day2, child.firstName, child.lastName, child.enrollmentId).map(time => (
                                                                        <option key={time} value={time}>{time}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <p className="text-sm text-gray-600">
                                                                {showName && child.grade}{ showName && " •"} <span className="font-medium text-orange-600">{child.subject}</span>
                                                            </p>
                                                            <p className="text-sm text-gray-500 mt-1">
                                                                Schedule: {reverseDayMap[child.day1]} {child.day1Time} & {reverseDayMap[child.day2]} {child.day2Time}
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="flex items-center space-x-2">
                                                    {hasPending && <span className="px-3 py-1 text-xs rounded-full bg-yellow-100 text-yellow-800">Pending Approval</span>}
                                                    <span className={`px-3 py-1 text-sm rounded-full ${child.status === 'ACTIVE' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>{child.status}</span>
                                                    {editingChildId === child.studentId ? (
                                                        <>
                                                            <button
                                                                onClick={handleSaveChild}
                                                                className="p-2 rounded-full bg-green-500 text-white hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                                                title="Save Child Details"
                                                            >
                                                                <i className="ri-check-line text-lg"></i>
                                                            </button>
                                                            <button
                                                                onClick={handleCancelChildEdit}
                                                                className="p-2 rounded-full bg-red-500 text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                                                                title="Cancel Edit"
                                                            >
                                                                <i className="ri-close-line text-lg"></i>
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <button
                                                            onClick={() => handleEditChildClick(child)}
                                                            disabled={hasPending || (hasPending && !showName)}
                                                            className="p-2 rounded-full bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-gray-300 disabled:cursor-not-allowed"
                                                            title={hasPending ? "A change request is pending approval" : "Edit Child Details"}
                                                        >
                                                            <i className="ri-edit-line text-lg"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="border-t border-gray-200">
                                                <div className="p-4">
                                                    <h5 className="text-sm font-medium text-gray-700 mb-3">Recent Attendance</h5>
                                                    <div className="grid grid-cols-6 gap-2">
                                                        {(child.attendance || []).slice(0, 12).map((att, idx) => (
                                                            <div key={idx} className={`flex flex-col items-center p-2 rounded ${att.present === true ? 'bg-green-50' : 'bg-red-50'}`}>
                                                                <span className="text-xs text-gray-600">{att.date}</span>
                                                                <i className={`${att.present === true ? 'ri-check-line text-green-500' : 'ri-close-line text-red-500'}`}></i>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )})}
                            </div>
                        </div>
                        <div className="mt-8" ref={paymentHistoryRef}>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Payment History</h3>
                            <div className="space-y-3">
                                {paymentHistory.slice(0, showAllPayments ? paymentHistory.length : 2).map((payment, idx) => (
                                    <div key={payment.paymentId || idx} className="flex items-start justify-between p-4 bg-gray-50 rounded-lg">
                                        <div className="flex items-center space-x-4">
                                            <div className="w-10 h-10 bg-green-100 rounded-full flex-shrink-0 flex items-center justify-center">
                                                <i className="ri-checkbox-circle-line text-green-600 text-xl"></i>
                                            </div>
                                            <div>
                                                <h4 className="font-medium text-gray-900">{payment.description}</h4>
                                                <p className="text-sm text-gray-600">Invoice Month: {formatInvoiceMonth(payment.invoiceMonth)}</p>
                                                <p className="text-sm text-gray-600">Classes Attended: {payment.classAttended}</p>
                                                <p className="text-sm text-gray-600">Fee Per Class: ${payment.feePerClass.toFixed(2)}</p>
                                                <p className="text-sm text-gray-600">Paid: {payment.paymentDate ? new Date(payment.paymentDate).toLocaleDateString() : 'N/A'}</p>
                                            </div>
                                        </div>
                                        <div className="text-right flex-shrink-0 ml-4">
                                            <p className="font-medium text-gray-900">${payment.amount.toFixed(2)}</p>
                                            <p className={`text-sm font-semibold ${payment.status === 'PAID' ? 'text-green-600' : 'text-red-600'}`}>{payment.status}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {paymentHistory.length > 2 && (
                                <div className="mt-4 text-right">
                                    <button
                                        onClick={() => setShowAllPayments(!showAllPayments)}
                                        className="text-primary hover:underline font-medium text-sm"
                                    >
                                        {showAllPayments ? 'Show Less' : 'Show More'}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="space-y-8">
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
                            <div className="space-y-3">
                                <button onClick={() => setCurrentPage('enrollment')} className="w-full flex items-center px-4 py-3 bg-white text-gray-700 rounded-lg hover:bg-gray-50 transition-all border border-gray-200 shadow-sm">
                                    <i className="ri-user-add-line text-primary mr-3"></i>
                                    <span>Enroll New Child</span>
                                </button>
                                <button onClick={() => setCurrentPage('paymentSetup')} className="w-full flex items-center px-4 py-3 bg-white text-gray-700 rounded-lg hover:bg-gray-50 transition-all border border-gray-200 shadow-sm">
                                    <i className="ri-wallet-line text-primary mr-3"></i>
                                    <span>{profileData.paymentMethod !== 'CASH' ? 'Update Auto Payment' : 'Auto Payment Setup'}</span>
                                </button>
                                <button
                                    onClick={() => {
                                        setShowAllPayments(true);
                                        setTimeout(() => paymentHistoryRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
                                    }}
                                    className="w-full flex items-center px-4 py-3 bg-white text-gray-700 rounded-lg hover:bg-gray-50 transition-all border border-gray-200 shadow-sm">
                                    <i className="ri-money-dollar-circle-line text-primary mr-3"></i>
                                    <span>Payment History</span>
                                </button>
                            </div>
                        </div>
                        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Autopay Status</h3>
                            <div className="space-y-4">
                                {/*<div className="flex justify-between items-center">*/}
                                {/* <span className="text-gray-600">Next Payment:</span>*/}
                                {/* <span className="font-medium text-gray-900">{profileData.nextPaymentDate ? new Date(profileData.nextPaymentDate).toLocaleDateString() : 'Not scheduled yet'}</span>*/}
                                {/*</div>*/}
                                <div className="flex justify-between items-center">
                                    <span className="text-gray-600">Payment Method:&nbsp;</span>
                                    <div className="text-right">
                                        {profileData.paymentMethod === 'CASH' && <span className="font-medium text-gray-900">Cash / Check</span>}
                                        {profileData.paymentMethod !== 'CASH' && !paymentMethodDetails && <span className="font-medium text-gray-500 text-sm">Loading details...</span>}
                                        {paymentMethodDetails?.type === 'card' && (
                                            <span className="font-medium text-gray-900 capitalize">{paymentMethodDetails.brand} **** {paymentMethodDetails.last4}</span>
                                        )}
                                        {paymentMethodDetails?.type === 'us_bank_account' && (
                                            <span className="font-medium text-gray-900 capitalize">{paymentMethodDetails.accountType} Account **** {paymentMethodDetails.last4}</span>
                                        )}
                                    </div>
                                </div>
                                <span>&nbsp;</span>
                            </div>

                            {paymentMethodDetails?.type === 'card' && (
                                    <div className="text-xs">
                                        <div className="max-w-lg mx-auto p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-800 text-center">
                                            <p><i className="ri-information-line align-middle mr-1"></i>A <strong>3% processing fee</strong> will be added to credit card payments.</p>
                                        </div>
                                    </div>

                            )}
                            {profileData.paymentMethod !== 'CASH' && (
                                <p className="text-xs text-gray-400 mt-4 text-center">
                                    <i className="ri-lock-line align-middle"></i> Payment information is securely managed by Stripe. We do not store any payment details. Fully PCI Compliant.
                                </p>
                            )}
                        </div>
                        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Last Month's Payment Status</h3>
                            {Object.entries(groupedLastMonthPayments).sort((a, b) => a[0].localeCompare(b[0])).map(([studentName, payments]) => (
                                <div key={studentName} className="mb-4">
                                    <h4 className="font-medium text-gray-800">{studentName}</h4>
                                    <ul className="mt-2 space-y-2">
                                        {payments.map((payment, idx) => (
                                            <li key={idx} className="flex justify-between items-center text-sm">
                                                <span className="text-gray-600">{payment.subject}:</span>
                                                <div className="flex items-center space-x-2">
                                                    {getAmountPaymentStatusChip(payment.status, payment.amount.toFixed(2))}
                                                    {getPaymentStatusChip(payment.status)}
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>

                        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Deposit Overview</h3>
                            {Object.entries(groupedDeposits).sort((a, b) => a[0].localeCompare(b[0])).map(([studentName, deposits]) => (
                                <div key={studentName} className="mb-4">
                                    <h4 className="font-medium text-gray-800">{studentName}</h4>
                                    <ul className="mt-2 space-y-2">
                                        {deposits.map((deposit, idx) => (
                                            <li key={`${deposit.studentId}-${deposit.subjectName}`} className="flex justify-between items-center text-sm">
                                                <span className="text-gray-600">{deposit.subjectName}:</span>
                                                <div className="flex items-center space-x-2">
                                                    <span className="font-medium text-gray-900">${deposit.depositAmount.toFixed(2)}</span>
                                                    {deposit.status === 'UNPAID' && profileData.paymentMethod !== 'CASH' ? (
                                                        <button onClick={() => handlePayDeposit(deposit.studentId)} className="px-3 py-1 text-xs rounded-md text-white bg-blue-600 hover:bg-blue-700">Pay Now</button>
                                                    ) : (
                                                        getDepositStatusChip(deposit.status)
                                                    )}
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                            {depositOverview.length === 0 && (
                                <p className="text-sm text-gray-500 text-center">No deposit information available.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Enrollment Page Component
const EnrollmentPage = ({ setCurrentPage, authData, locations, userProfile, studentForEnrollment, setStudentForEnrollment, onDataRefresh }) => {
    const [formData, setFormData] = useState({
        childFirstName: '',
        childLastName: '',
        grade: '',
        subject: '',
        subjectId: '',
        day1: '',
        time1: '',
        day2: '',
        time2: '',
        locationId: authData?.locationId || ''
    });

    const [subjects, setSubjects] = useState([]);
    const [batches, setBatches] = useState([]);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const [dropdowns, setDropdowns] = useState({
        grade: false,
        subject: false
    });

    // Determine if this is for an additional subject for an existing student
    const isAdditionalSubject = useMemo(() => studentForEnrollment !== null, [studentForEnrollment]);

    // Pre-fill form if enrolling an existing student
    useEffect(() => {
        if (isAdditionalSubject) {
            setFormData(prev => ({
                ...prev,
                childFirstName: studentForEnrollment.firstName,
                childLastName: studentForEnrollment.lastName,
                grade: studentForEnrollment.enrollments[0]?.grade || '', // Use grade from first enrollment
            }));
        } else {
            setFormData(prev => ({ ...prev, childLastName: userProfile?.lastName || '' }));
        }
    }, [studentForEnrollment, isAdditionalSubject, userProfile]);


    const dayMap = { Mon: 'MONDAY', Tue: 'TUESDAY', Wed: 'WEDNESDAY', Thu: 'THURSDAY', Fri: 'FRIDAY', Sat: 'SATURDAY', Sun: 'SUNDAY' };
    const reverseDayMap = { MONDAY: 'Mon', TUESDAY: 'Tue', WEDNESDAY: 'Wed', THURSDAY: 'Thu', FRIDAY: 'Fri', SATURDAY: 'Sat', SUNDAY: 'Sun' };

    const availableDaysShort = useMemo(() => {
        const dayOrder = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        const availableDays = [...new Set(batches.map(b => reverseDayMap[b.dayOfWeek.toUpperCase()]))];
        availableDays.sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));
        return availableDays;
    }, [batches]);

    const getTimeOptionsForDay = (day, allBatches) => {
        if (!day) return [];
        const fullDay = dayMap[day];
        return allBatches
            .filter(b => b.dayOfWeek.toUpperCase() === fullDay)
            .map(b => b.timeSlot)
            .sort();
    };

    useEffect(() => {
        if (!authData?.token || !formData.locationId) return;

        const fetchCourseData = async () => {
            setError(''); // Clear previous errors on new fetch
            try {
                const [subjectsRes, batchesRes] = await Promise.all([
                    apiFetch('/admin/subjects', {}, authData.token),
                    apiFetch(`/admin/batches?locationId=${formData.locationId}`, {}, authData.token)
                ]);
                const fetchedSubjects = subjectsRes || [];
                const fetchedBatches = batchesRes || [];
                setSubjects(fetchedSubjects);
                setBatches(fetchedBatches);

                if (fetchedBatches.length > 0 && !isAdditionalSubject) {
                    const defaultDay1 = 'Mon';
                    const defaultDay2 = 'Sat';

                    const day1Times = getTimeOptionsForDay(defaultDay1, fetchedBatches);
                    const day2Times = getTimeOptionsForDay(defaultDay2, fetchedBatches);

                    setFormData(prev => ({
                        ...prev,
                        day1: day1Times.length > 0 ? defaultDay1 : '',
                        time1: day1Times.length > 0 ? day1Times[0] : '',
                        day2: day2Times.length > 0 ? defaultDay2 : '',
                        time2: day2Times.length > 0 ? day2Times[0] : ''
                    }));
                }

            } catch (err) {
                console.error("Failed to fetch course data:", err);
                setError("Could not load schedule information. Please try again later.");
            }
        };

        fetchCourseData();
    }, [authData, formData.locationId, isAdditionalSubject]);

    // Filter subjects to exclude those the student is already enrolled in
    const enrolledSubjectNames = useMemo(() =>
            isAdditionalSubject ? studentForEnrollment.enrollments.map(e => e.subject) : [],
        [studentForEnrollment, isAdditionalSubject]);

    const availableSubjects = useMemo(() =>
            subjects.filter(s => !enrolledSubjectNames.includes(s.name)),
        [subjects, enrolledSubjectNames]);


    const getTimeOptions = (day) => {
        if (!day) return [];
        const fullDay = dayMap[day];

        const allTimesForDay = batches
            .filter(b => b.dayOfWeek.toUpperCase() === fullDay)
            .map(b => b.timeSlot)
            .sort();

        if (isAdditionalSubject) {
            const existingTimesOnDay = studentForEnrollment.enrollments.flatMap(e => {
                const times = [];
                if (reverseDayMap[e.day1] === day) times.push(e.day1Time);
                if (reverseDayMap[e.day2] === day) times.push(e.day2Time);
                return times;
            });
            return allTimesForDay.filter(time => !existingTimesOnDay.includes(time));
        }
        return allTimesForDay;
    };

    const isWeekend = (day) => ['Sat', 'Sun'].includes(day);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleDaySelection = (dayField, day) => {
        setFormData(prev => {
            const otherDayField = dayField === 'day1' ? 'day2' : 'day1';
            if (prev[otherDayField] === day) return prev; // Prevent selecting the same day

            const newTimeField = dayField === 'day1' ? 'time1' : 'time2';
            const newTimeOptions = getTimeOptions(day);
            const currentTime = prev[newTimeField];

            if (!newTimeOptions.includes(currentTime)) {
                return { ...prev, [dayField]: day, [newTimeField]: newTimeOptions[0] || '' };
            }
            return { ...prev, [dayField]: day };
        });
    };

    const handleTimeSelection = (timeField, time) => {
        setFormData(prev => ({ ...prev, [timeField]: time }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!formData.childFirstName || !formData.childLastName || !formData.grade || !formData.subjectId || !formData.day1 || !formData.time1 || !formData.day2 || !formData.time2) {
            setError("Please fill out all fields.");
            return;
        }
        if (formData.day1 === formData.day2) {
            setError("Day 1 and Day 2 cannot be the same.");
            return;
        }

        const findBatchId = (day, time) => {
            const fullDay = dayMap[day];
            const batch = batches.find(b => b.dayOfWeek.toUpperCase() === fullDay && b.timeSlot === time);
            return batch ? batch.batchId : null;
        };

        const batchId1 = findBatchId(formData.day1, formData.time1);
        const batchId2 = findBatchId(formData.day2, formData.time2);

        if (!batchId1 || !batchId2) {
            setError("Selected class time is not available. Please refresh and try again.");
            return;
        }

        const enrollmentData = {
            parentUserId: authData.userId,
            childFirstName: formData.childFirstName,
            childLastName: formData.childLastName,
            grade: formData.grade,
            subjectId: formData.subjectId,
            locationId: formData.locationId,
            batchIds: [batchId1, batchId2]
        };

        try {
            await apiFetch('/students', {
                method: 'POST',
                body: JSON.stringify(enrollmentData)
            }, authData.token);

            setStudentForEnrollment(null); // Clear the state

            await onDataRefresh(); // Refresh parent data

            // Check if user has autopay setup
            if (userProfile && userProfile.paymentMethod !== 'CASH') {
                setMessage('Child enrolled successfully! Redirecting to your dashboard...');
                setTimeout(() => setCurrentPage('profile'), 2000);
            } else {
                setMessage('Child enrolled successfully! Proceeding to payment setup...');
                setTimeout(() => setCurrentPage('paymentSetup'), 2000);
            }

        } catch (error) {
            setError(`Enrollment failed: ${error.message}`);
        }
    };

    const toggleDropdown = (dropdownName) => {
        setDropdowns(prev => ({
            ...Object.fromEntries(Object.keys(prev).map(key => [key, key === dropdownName ? !prev[key] : false])),
        }));
    };

    const selectOption = (type, value, id = null) => {
        if (type === 'subject') {
            setFormData(prev => ({ ...prev, subject: value, subjectId: id }));
        } else {
            setFormData(prev => ({ ...prev, [type]: value }));
        }
        setDropdowns(prev => ({ ...prev, [type]: false }));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.relative')) {
                setDropdowns({ grade: false, subject: false });
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const isFormInvalid = !formData.childFirstName || !formData.childLastName || !formData.grade || !formData.subjectId || !formData.day1 || !formData.time1 || !formData.day2 || !formData.time2;

    const grades = ['Kindergarten', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'];
    // {grades.map(grade => (
    //     <option key={grade} value={grade}>{grade}</option>
    // ))}

    return (
        <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-book-open-line text-primary text-xl"></i>
                </div>
                <h2 className="text-2xl font-bold text-gray-900">Child Enrollment</h2>
            </div>
            <div className="text-center mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">{isAdditionalSubject ? 'Enroll in Additional Subject' : 'Enroll New Child'}</h1>
                <p className="text-gray-600">Begin your child journey to academic excellence</p>
            </div>
            <form className="space-y-8 max-w-2xl mx-auto" onSubmit={handleSubmit}>
                {error && <div className="bg-red-100 text-red-700 p-3 rounded-lg text-center my-4">{error}</div>}
                {message && <div className="bg-green-100 text-green-700 p-3 rounded-lg text-center my-4">{message}</div>}

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Child Name</label>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <input type="text" name="childFirstName" value={formData.childFirstName} onChange={handleChange}
                               readOnly={isAdditionalSubject}
                               className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm ${isAdditionalSubject ? 'bg-gray-100' : 'border-gray-300'}`}
                               placeholder="First Name" required/>
                        <input type="text" name="childLastName" value={formData.childLastName} onChange={handleChange}
                               readOnly={isAdditionalSubject}
                               className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm ${isAdditionalSubject ? 'bg-gray-100' : 'border-gray-300'}`}
                               placeholder="Last Name" required/>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Grade</label>
                        <div className="relative">
                            <button type="button"
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-left text-sm text-gray-500 hover:border-primary focus:ring-2 focus:ring-primary focus:border-transparent flex items-center justify-between"
                                    onClick={() => toggleDropdown('grade')}>
                                <span id="grade-selected">{formData.grade || 'Select grade'}</span>
                                <div className="w-5 h-5 flex items-center justify-center">
                                    <i className="ri-arrow-down-s-line"></i>
                                </div>
                            </button>
                            {dropdowns.grade && (
                                <div className="absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-lg mt-1 shadow-lg z-10">
                                    <div className="py-2">
                                        {grades.map(grade => (
                                            <button key={grade} type="button" className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50"
                                                    onClick={() => selectOption('grade', grade)}>{grade}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Subject</label>
                        <div className="relative">
                            <button type="button"
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-left text-sm text-gray-500 hover:border-primary focus:ring-2 focus:ring-primary focus:border-transparent flex items-center justify-between"
                                    onClick={() => toggleDropdown('subject')}>
                                <span id="subject-selected">{formData.subject || 'Select subject'}</span>
                                <div className="w-5 h-5 flex items-center justify-center">
                                    <i className="ri-arrow-down-s-line"></i>
                                </div>
                            </button>
                            {dropdowns.subject && (
                                <div className="absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-lg mt-1 shadow-lg z-10">
                                    <div className="py-2">
                                        {availableSubjects.map(subject => (
                                            <button key={subject.subjectId} type="button" className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50"
                                                    onClick={() => selectOption('subject', subject.name, subject.subjectId)}>{subject.name}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-4">Select Day 1</label>
                        <div className="grid grid-cols-4 gap-2">
                            {availableDaysShort.map(day => (
                                <button key={day} type="button"
                                        disabled={formData.day2 === day}
                                        className={`px-4 py-2 border rounded-lg text-sm hover:border-primary focus:ring-2 focus:ring-primary ${formData.day1 === day ? 'bg-primary text-white border-primary' : 'border-gray-300'} ${formData.day2 === day ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        onClick={() => handleDaySelection('day1', day)}>
                                    {day}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-4">
                            Select Day 1 Time
                            {formData.day1 && (
                                <span className="text-gray-500 font-normal ml-1">
                                    {isWeekend(formData.day1) ? '(Weekend Time)' : "(Weekday's Time)"}
                                </span>
                            )}
                        </label>
                        <div className="grid grid-cols-2 gap-2">
                            {getTimeOptions(formData.day1).map(time => (
                                <button key={time} type="button"
                                        className={`px-4 py-2 border rounded-lg text-sm hover:border-primary focus:ring-2 focus:ring-primary ${formData.time1 === time ? 'bg-primary text-white border-primary' : 'border-gray-300'}`}
                                        onClick={() => handleTimeSelection('time1', time)}>
                                    {time}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-4">Select Day 2</label>
                        <div className="grid grid-cols-4 gap-2">
                            {availableDaysShort.map(day => (
                                <button key={day} type="button"
                                        disabled={formData.day1 === day}
                                        className={`px-4 py-2 border rounded-lg text-sm hover:border-primary focus:ring-2 focus:ring-primary ${formData.day2 === day ? 'bg-primary text-white border-primary' : 'border-gray-300'} ${formData.day1 === day ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        onClick={() => handleDaySelection('day2', day)}>
                                    {day}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-4">
                            Select Day 2 Time
                            {formData.day2 && (
                                <span className="text-gray-500 font-normal ml-1">
                                    {isWeekend(formData.day2) ? '(Weekend Time)' : "(Weekday's Time)"}
                                </span>
                            )}
                        </label>
                        <div className="grid grid-cols-2 gap-2">
                            {getTimeOptions(formData.day2).map(time => (
                                <button key={time} type="button"
                                        className={`px-4 py-2 border rounded-lg text-sm hover:border-primary focus:ring-2 focus:ring-primary ${formData.time2 === time ? 'bg-primary text-white border-primary' : 'border-gray-300'}`}
                                        onClick={() => handleTimeSelection('time2', time)}>
                                    {time}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="flex justify-end space-x-4 mt-8">
                    <button type="button"
                            onClick={() => {
                                setStudentForEnrollment(null);
                                setCurrentPage('profile');
                            }}
                            className="bg-gray-100 text-gray-700 py-3 px-6 rounded-button font-medium hover:bg-gray-200 transition-colors whitespace-nowrap">
                        Back
                    </button>
                    <button type="submit"
                            disabled={isFormInvalid}
                            className="bg-primary text-white py-3 px-6 rounded-button font-medium hover:bg-blue-700 transition-colors whitespace-nowrap disabled:bg-gray-400 disabled:cursor-not-allowed">
                        Submit Enrollment
                    </button>
                </div>
            </form>
        </div>
    );
};


// --- NEW: Stripe Checkout Form Component ---
const CheckoutForm = ({ authData, setCurrentPage, onDataRefresh }) => {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        setIsLoading(true);

        const { error: submitError } = await elements.submit();
        if (submitError) {
            setMessage(submitError.message);
            setIsLoading(false);
            return;
        }

        const { error, setupIntent } = await stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: `${window.location.origin}/payment-setup-complete`, // A placeholder success URL
            },
            redirect: 'if_required',
        });

        if (error) {
            if (error.type === "card_error" || error.type === "validation_error") {
                setMessage(error.message);
            } else {
                setMessage("An unexpected error occurred.");
            }
        } else if (setupIntent && setupIntent.status === 'succeeded') {
            try {
                await apiFetch(`/payments/save-method/${authData.userId}`, {
                    method: 'POST',
                    body: JSON.stringify({ paymentMethodId: setupIntent.payment_method }),
                }, authData.token);

                await onDataRefresh(); // Refresh parent data

                setMessage('Payment method saved successfully! Redirecting to dashboard...');
                setTimeout(() => setCurrentPage('profile'), 2000);
            } catch (apiError) {
                setMessage(`Failed to save payment method: ${apiError.message}`);
            }
        } else {
            setMessage('An unexpected error occurred.');
        }

        setIsLoading(false);
    };

    const paymentElementOptions = {
        layout: "tabs"
    };

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            <PaymentElement id="payment-element" options={paymentElementOptions} />
            <button disabled={isLoading || !stripe || !elements} id="submit" className="w-full bg-primary text-white py-3 px-6 rounded-button font-medium hover:bg-blue-700 transition-colors !rounded-button whitespace-nowrap mt-6 disabled:opacity-50">
                <span id="button-text">
                    {isLoading ? <div className="spinner" id="spinner"></div> : "Save Payment Method"}
                </span>
            </button>
            {message && <div id="payment-message" className="mt-4 text-center text-red-500">{message}</div>}
            <div className="mt-6 text-center text-xs text-gray-500">
                <div className="flex items-center justify-center">
                    <i className="ri-lock-line align-middle"></i>
                    <span className="ml-1 align-middle">
                        Secure payments Powered by Stripe. We do not store your financial information. Fully PCI Compliant.
                    </span>
                </div>
            </div>
        </form>
    );
};


// --- UPDATED: Payment Setup Page Component ---
const PaymentSetupPage = ({ setCurrentPage, authData, onDataRefresh }) => {
    const [clientSecret, setClientSecret] = useState('');

    useEffect(() => {
        const fetchSetupIntent = async () => {
            try {
                // NOTE: For ACH to appear, your backend endpoint /payments/setup-intent/{userId}
                // must create a Stripe SetupIntent that includes 'us_bank_account' in the payment method types.
                const response = await apiFetch(`/payments/setup-intent/${authData.userId}`, { method: 'POST' }, authData.token);
                setClientSecret(response.clientSecret);
            } catch (error) {
                console.error("Failed to fetch setup intent:", error);
            }
        };
        if (authData?.userId && authData?.token) {
            fetchSetupIntent();
        }
    }, [authData]);

    const appearance = {
        theme: 'stripe',
        labels: 'floating'
    };

    // The order of tabs is automatically optimized by Stripe. ACH will be prioritized for US-based customers.
    const options = {
        clientSecret,
        appearance,
    };

    return (
        <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="text-center mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">
                    Payment Setup
                    <span className="text-sm font-normal text-gray-500 ml-2">(<span className="ri-lock-line">Powered by Stripe</span>)</span>
                </h1>

                <p className="text-gray-600">Securely add your payment method for automatic billing.</p>
            </div>
            <div className="text-center mb-8">
                <div className="max-w-lg mx-auto p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-800 text-center">
                    <p><i className="ri-information-line align-middle mr-1"></i>A <strong>3% processing fee</strong> will be added to credit card payments.</p>
                    <p className="text-green-800"><i className="align-middle mr-1"></i>There is <strong>no additional fee</strong> for ACH (US bank account) payments.</p>
                </div>
            </div>

            <div className="max-w-lg mx-auto">
                {clientSecret ? (
                    <Elements options={options} stripe={stripePromise}>
                        <CheckoutForm authData={authData} setCurrentPage={setCurrentPage} onDataRefresh={onDataRefresh} />
                    </Elements>
                ) : (
                    <div className="text-center">Loading payment form...</div>
                )}
            </div>
        </div>
    );
};


// --- UPDATED: Footer Component ---
const Footer = ({ setCurrentPage }) => {
    const handleNavClick = (e, targetId) => {
        e.preventDefault();
        setCurrentPage('landing');
        setTimeout(() => {
            const element = document.querySelector(targetId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 0);
    };

    const handlePageChange = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
    };

    return (
        <footer id="contact" class="bg-gray-900 text-white pt-16 pb-8">
            <div className="container mx-auto px-4 max-w-7xl">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
                    <div>
                        <a href="#home" onClick={(e) => handleNavClick(e, '#home')} id="brand-logo-footer"
                           className="text-3xl font-['Poppins'] font-bold hover:opacity-80 transition-opacity mb-6 block">
                            {/*<span className="text-white">smartmath</span>*/}
                            <img src="images/logo-main-clear.svg" alt="SmartMath"/>
                        </a>
                        <p className="text-gray-400 mb-6">Providing expert tutoring services since 2016, helping
                            students
                            achieve academic excellence through personalized learning plans.</p>
                        {/*<div className="flex space-x-4">*/}
                        {/* <a href="#"*/}
                        {/* className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition">*/}
                        {/* <i className="ri-facebook-fill"></i>*/}
                        {/* </a>*/}
                        {/* <a href="#"*/}
                        {/* className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition">*/}
                        {/* <i className="ri-twitter-x-fill"></i>*/}
                        {/* </a>*/}
                        {/* <a href="#"*/}
                        {/* className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition">*/}
                        {/* <i className="ri-instagram-fill"></i>*/}
                        {/* </a>*/}
                        {/* <a href="#"*/}
                        {/* className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition">*/}
                        {/* <i className="ri-linkedin-fill"></i>*/}
                        {/* </a>*/}
                        {/*</div>*/}
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
                        <ul className="space-y-3">

                            {/*<li><a href="#" onClick={(e) => handlePageChange(e, 'login')} className="text-gray-400 hover:text-white transition">Login</a></li>
                            <li><a href="#" onClick={(e) => handlePageChange(e, 'profile')} className="text-gray-400 hover:text-white transition">Dashboard</a></li>*/}

                            <li><a href="#home" onClick={(e) => handleNavClick(e, '#home')} className="text-gray-400 hover:text-white transition">Home</a></li>
                            <li><a href="#mission" onClick={(e) => handleNavClick(e, '#mission')} className="text-gray-400 hover:text-white transition">Our Mission</a>
                            </li>
                            <li><a href="#courses" onClick={(e) => handleNavClick(e, '#courses')} className="text-gray-400 hover:text-white transition">Courses</a>
                            </li>
                            <li><a href="#summer" onClick={(e) => handleNavClick(e, '#summer')} className="text-gray-400 hover:text-white transition">Summer
                                Program</a></li>
                            <li><a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-gray-400 hover:text-white transition">About Me</a></li>


                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
                        <ul className="space-y-3">
                            <li className="flex items-start">
                                <i className="ri-map-pin-line mt-1 mr-3 text-primary"></i>
                                <span className="text-gray-400">3759 US-1<br/>Monmouth Junction, NJ 08852<br/>Suite #201</span>
                            </li>
                            <li className="flex items-center">
                                <i className="ri-phone-line mr-3 text-primary"></i>
                                <span className="text-gray-400">862-242-9067</span>
                            </li>
                            <li className="flex items-center">
                                <i className="ri-mail-line mr-3 text-primary"></i>
                                <span className="text-gray-400">smartmath28@gmail.com</span>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold mb-6">Hours of Operation</h3>
                        <ul className="space-y-3">
                            <li className="flex items-center">
                                <i className="ri-time-line mr-3 text-primary"></i>
                                <div>
                                    <p className="text-gray-400">Monday - Friday</p>
                                    <p className="text-white font-medium">4:30 PM - 8:30 PM</p>
                                </div>
                            </li>
                            <li className="flex items-center">
                                <i className="ri-time-line mr-3 text-primary"></i>
                                <div>
                                    <p className="text-gray-400">Weekend</p>
                                    <p className="text-white font-medium">9:00 AM - 12:00 PM</p>
                                </div>
                            </li>
                        </ul>
                        {/*<div className="mt-6 pt-6 border-t border-gray-800">*/}
                        {/* <div className="flex items-center space-x-4">*/}
                        {/* <i className="ri-visa-fill text-2xl text-gray-400"></i>*/}
                        {/* </div>*/}
                        {/*</div>*/}
                    </div>
                </div>
                <div className="pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
                    <p>&copy; {new Date().getFullYear()} Smartmath Tutoring. All rights reserved.</p>
                    <div className="flex justify-center space-x-6 mt-4">
                        {/*<a href="#" className="hover:text-white transition">Privacy Policy</a>*/}
                        {/*<a href="#" className="hover:text-white transition">Terms of Service</a>*/}
                        {/*<a href="#" className="hover:text-white transition">Cookie Policy</a>*/}
                        <a href="#" onClick={(e) => handlePageChange(e, 'terms')} className="text-gray-400 hover:text-white transition">Terms of Service</a>
                        <a href="#" onClick={(e) => handlePageChange(e, 'privacy')} className="text-gray-400 hover:text-white transition">Privacy Policy</a>
                        <a href="#" onClick={(e) => handlePageChange(e, 'cookies')} className="text-gray-400 hover:text-white transition">Cookie Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

// --- NEW: Terms of Service Page ---
const TermsOfServicePage = ({ setCurrentPage }) => {
    return (
        <div className="bg-white rounded-xl shadow-lg p-8 max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service</h1>
            <div className="prose max-w-none text-gray-700">
                <p>Last updated: {new Date().toLocaleDateString()}</p>
                <p>Please read these Terms of Service ("Terms") carefully before using the SmartMath website and services (the "Service") operated by us.</p>

                <h2>1. Agreement to Terms</h2>
                <p>By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.</p>

                <h2>2. Services</h2>
                <p>SmartMath provides online tutoring and educational services. We reserve the right to modify or discontinue the Service at any time without notice.</p>

                <h2>3. Accounts</h2>
                <p>When you create an account with us, you must provide information that is accurate, complete, and current. You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password.</p>

                <h2>4. Payments and Refunds</h2>
                <p>Fees for our services are billed on a subscription basis or as otherwise described at the time of purchase. All payments are handled through our third-party payment processor (Stripe). Refund policies will be provided at the time of enrollment.</p>

                <h2>5. Intellectual Property</h2>
                <p>The Service and its original content, features, and functionality are and will remain the exclusive property of SmartMath and its licensors.</p>

                <h2>6. Limitation of Liability</h2>
                <p>In no event shall SmartMath, nor its directors, employees, or partners, be liable for any indirect, incidental, special, consequential or punitive damages resulting from your use of the Service.</p>

                <h2>7. Governing Law</h2>
                <p>These Terms shall be governed by the laws of your jurisdiction, without regard to its conflict of law provisions.</p>

                <h2>8. Changes to Terms</h2>
                <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide at least 30 days' notice prior to any new terms taking effect.</p>

                <h2>9. Contact Us</h2>
                <p>If you have any questions about these Terms, please contact us at smartmath28@gmail.com.</p>
            </div>
        </div>
    );
};

// --- NEW: Privacy Policy Page ---
const PrivacyPolicyPage = ({ setCurrentPage }) => {
    return (
        <div className="bg-white rounded-xl shadow-lg p-8 max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
            <div className="prose max-w-none text-gray-700">
                <p>Last updated: {new Date().toLocaleDateString()}</p>
                <p>This Privacy Policy describes how SmartMath ("we," "us," or "our") collects, uses, and discloses your information.</p>

                <h2>1. Information We Collect</h2>
                <p>We may collect the following types of information:</p>
                <ul>
                    <li><strong>Personal Information:</strong> Name, email address, phone number, and information about your child (name, grade).</li>
                    <li><strong>Payment Information:</strong> We use a third-party processor (Stripe) to handle payments. We do not store your full credit card or bank account details.</li>
                    <li><strong>Usage Information:</strong> Information about how you access and use our Service.</li>
                </ul>

                <h2>2. How We Use Your Information</h2>
                <p>We use the information we collect to:</p>
                <ul>
                    <li>Provide, operate, and maintain our Service.</li>
                    <li>Process your transactions and manage your account.</li>
                    <li>Communicate with you, including for customer service and support.</li>
                    <li>Improve and personalize our Service.</li>
                </ul>

                <h2>3. How We Share Your Information</h2>
                <p>We do not sell your personal information. We may share it with third-party service providers who perform services on our behalf, such as payment processing and data analysis.</p>

                <h2>4. Data Security</h2>
                <p>We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that no security measures are perfect or impenetrable.</p>

                <h2>5. Your Rights</h2>
                <p>You have the right to access, update, or delete the information we have on you. You can do this by logging into your profile page or contacting us directly.</p>

                <h2>6. Contact Us</h2>
                <p>If you have any questions about this Privacy Policy, please contact us at smartmath28@gmail.com.</p>
            </div>
        </div>
    );
};

// --- NEW: Cookie Policy Page ---
const CookiePolicyPage = ({ setCurrentPage }) => {
    return (
        <div className="bg-white rounded-xl shadow-lg p-8 max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Cookie Policy</h1>
            <div className="prose max-w-none text-gray-700">
                <p>Last updated: {new Date().toLocaleDateString()}</p>

                <h2>1. What Are Cookies?</h2>
                <p>Cookies are small text files placed on your device when you visit a website. They are widely used to make websites work more efficiently, as well as to provide information to the site owners.</p>

                <h2>2. How We Use Cookies</h2>
                <p>We use cookies for the following purposes:</p>
                <ul>
                    <li><strong>Essential Cookies:</strong> These are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you, such as logging in or filling in forms.</li>
                    <li><strong>Performance Cookies:</strong> These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site.</li>
                    <li><strong>Functionality Cookies:</strong> These are used to recognize you when you return to our website and enable us to personalize our content for you.</li>
                </ul>

                <h2>3. Your Choices</h2>
                <p>Most web browsers allow some control of most cookies through the browser settings. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work.</p>

                <h2>4. Contact Us</h2>
                <p>If you have any questions about our use of cookies, please contact us at smartmath28@gmail.com.</p>
            </div>
        </div>
    );
};

// Main ParentApp Component for Parent Portal
export default function ParentApp() {
    // Initialize authData state from localStorage
    const getInitialAuthData = () => {
        const savedData = localStorage.getItem('smartmath_auth');
        if (savedData) {
            try {
                return JSON.parse(savedData);
            } catch (e) {
                console.error("Failed to parse auth data from localStorage", e);
                localStorage.removeItem('smartmath_auth');
                return null;
            }
        }
        return null;
    };

    const [authData, setAuthData] = useState(getInitialAuthData);
    // Set initial page based on whether we have auth data
    const [currentPage, setCurrentPage] = useState(authData ? 'profile' : 'landing');
    const [locations, setLocations] = useState([]);
    const [emailForReset, setEmailForReset] = useState('');
    const [userProfile, setUserProfile] = useState(null);
    const [studentForEnrollment, setStudentForEnrollment] = useState(null);

    const isLoggedIn = !!authData;

    const handleLogout = () => {
        localStorage.removeItem('smartmath_auth');
        setAuthData(null);
        setUserProfile(null);
        setCurrentPage('landing');
    };

    const fetchUserProfile = async () => {
        if (authData) {
            try {
                const profile = await apiFetch(`/users/${authData.userId}`, {}, authData.token);
                setUserProfile(profile);
            } catch (error) {
                console.error("Failed to fetch user profile", error);
                handleLogout(); // Logout if token is bad
            }
        }
    };

    useEffect(() => {
        fetchUserProfile();
    }, [authData]);

    // --- ADDED: Scroll to top on page change ---
    useEffect(() => {
        // This ensures that when a new page is rendered, the view starts from the top.
        // The exception for 'landing' is to allow smooth scrolling to anchors to work correctly.
        if (currentPage !== 'landing') {
            window.scrollTo(0, 0);
        }
    }, [currentPage]);

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await apiFetch('/enrollment/locations');
                if (response) {
                    setLocations(response);
                }
            } catch (err) {
                console.error("Failed to fetch locations:", err);
            }
        };
        fetchLocations();
    }, []);

    const handleLogin = (data) => {
        localStorage.setItem('smartmath_auth', JSON.stringify(data));
        setAuthData(data);
        setCurrentPage('profile');
    };

    const renderPage = () => {
        // Always render landing page content if not logged in and on landing
        if (currentPage === 'landing') {
            return <LandingPage setCurrentPage={setCurrentPage} isLoggedIn={isLoggedIn} />;
        }

        // For portal pages, wrap them in a container
        let portalContent;
        if (!isLoggedIn) {
            switch (currentPage) {

                case 'terms':
                    portalContent =  <TermsOfServicePage setCurrentPage={setCurrentPage} />;
                    break;
                case 'privacy':
                    portalContent = <PrivacyPolicyPage setCurrentPage={setCurrentPage} />;
                    break;
                case 'cookies':
                    portalContent = <CookiePolicyPage setCurrentPage={setCurrentPage} />;
                    break;
                case 'registration':
                    portalContent = <RegistrationPage setCurrentPage={setCurrentPage} locations={locations}/>;
                    break;
                case 'forgotPassword':
                    portalContent =
                        <ForgotPasswordPage setCurrentPage={setCurrentPage} setEmailForReset={setEmailForReset}/>;
                    break;
                case 'resetPassword':
                    portalContent = <ResetPasswordPage setCurrentPage={setCurrentPage} email={emailForReset}
                                                       onLogin={handleLogin}/>;
                    break;
                case 'login':
                default:
                    portalContent = <LoginPage setCurrentPage={setCurrentPage} onLogin={handleLogin}/>;
                    break;
            }
        } else {
            switch (currentPage) {
                case 'enrollment':
                    portalContent = <EnrollmentPage
                        setCurrentPage={setCurrentPage}
                        authData={authData}
                        locations={locations}
                        userProfile={userProfile}
                        studentForEnrollment={studentForEnrollment}
                        setStudentForEnrollment={setStudentForEnrollment}
                        onDataRefresh={fetchUserProfile}
                    />;
                    break;
                case 'paymentSetup':
                    portalContent = <PaymentSetupPage
                        setCurrentPage={setCurrentPage}
                        authData={authData}
                        onDataRefresh={fetchUserProfile}
                    />;
                    break;
                case 'profile':
                default:
                    portalContent = <PersonalProfilePage
                        setCurrentPage={setCurrentPage}
                        authData={authData}
                        userProfile={userProfile}
                        onDataRefresh={fetchUserProfile}
                        setStudentForEnrollment={setStudentForEnrollment}
                    />;
                    break;
            }
        }

        return (
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex-grow w-full">
                <div className="max-w-6xl mx-auto py-12 space-y-12">
                    {portalContent}
                </div>
            </div>
        )
    };

    return (
        <div className="bg-gray-50 min-h-screen flex flex-col">
            <style>
                {`
                .gradient-bg {
                    background: linear-gradient(135deg, #e0e7ff, #ffffff);
                }
                .feature-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
                }
                .testimonial-card {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }
                .testimonial-card:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .fade-in {
                    animation: fadeIn 1s ease-out forwards;
                }
                :where([class^="ri-"])::before {
                  content: "\\f3c2";
                }
                .custom-radio {
                  width: 20px;
                  height: 20px;
                  border: 2px solid #d1d5db;
                  border-radius: 50%;
                  position: relative;
                  transition: all 0.2s;
                }
                .custom-radio::after {
                  content: '';
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  background: #1e40af;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%) scale(0);
                  transition: transform 0.2s;
                }
                input[type="radio"]:checked + .custom-radio {
                  border-color: #1e40af;
                }
                input[type="radio"]:checked + .custom-radio::after {
                  transform: translate(-50%, -50%) scale(1);
                }
                .custom-switch {
                  position: relative;
                  display: flex;
                  align-items: center;
                }
                .switch-label {
                  display: block;
                  width: 48px;
                  height: 24px;
                  background: #d1d5db;
                  border-radius: 12px;
                  cursor: pointer;
                  position: relative;
                  transition: background 0.3s;
                }
                .switch-label::after {
                  content: '';
                  width: 20px;
                  height: 20px;
                  background: white;
                  border-radius: 50%;
                  position: absolute;
                  top: 2px;
                  left: 2px;
                  transition: transform 0.3s;
                  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                }
                input[type="checkbox"]:checked + .switch-label {
                  background: #1e40af;
                }
                input[type="checkbox"]:checked + .switch-label::after {
                  transform: translateX(24px);
                }
                .spinner,
                .spinner:before,
                .spinner:after {
                  border-radius: 50%;
                  width: 1.5em;
                  height: 1.5em;
                  -webkit-animation-fill-mode: both;
                  animation-fill-mode: both;
                  -webkit-animation: load7 1.8s infinite ease-in-out;
                  animation: load7 1.8s infinite ease-in-out;
                }
                .spinner {
                  color: #ffffff;
                  font-size: 5px;
                  margin: 0 auto;
                  position: relative;
                  text-indent: -9999em;
                  -webkit-transform: translateZ(0);
                  -ms-transform: translateZ(0);
                  transform: translateZ(0);
                  -webkit-animation-delay: -0.16s;
                  animation-delay: -0.16s;
                }
                .spinner:before,
                .spinner:after {
                  content: '';
                  position: absolute;
                  top: 0;
                }
                .spinner:before {
                  left: -3.5em;
                  -webkit-animation-delay: -0.32s;
                  animation-delay: -0.32s;
                }
                .spinner:after {
                  left: 3.5em;
                }
                @-webkit-keyframes load7 {
                  0%,
                  80%,
                  100% {
                    box-shadow: 0 2.5em 0 -1.3em;
                  }
                  40% {
                    box-shadow: 0 2.5em 0 0;
                  }
                }
                @keyframes load7 {
                  0%,
                  80%,
                  100% {
                    box-shadow: 0 2.5em 0 -1.3em;
                  }
                  40% {
                    box-shadow: 0 2.5em 0 0;
                  }
                }
                `}
            </style>
            <script src="https://cdn.tailwindcss.com/3.4.16"></script>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap" rel="stylesheet" />
            <link href="https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.css" rel="stylesheet"/>
            <script>
                {`
                tailwind.config = {
                    theme: {
                        extend: {
                            colors: {
                                primary: '#1e3a8a',
                                secondary: '#f97316',
                                light: '#f0f5ff',
                                dark: '#1a202c',
                            },
                            borderRadius: {
                                'button': '8px',
                            },
                            fontFamily: {
                                sans: ['Poppins', 'sans-serif'],
                            },
                        }
                    }
                }
                `}
            </script>

            <Header
                setCurrentPage={setCurrentPage}
                isLoggedIn={isLoggedIn}
                onLogout={handleLogout}
            />

            <main className="flex-grow">
                {renderPage()}
            </main>

            <Footer setCurrentPage={setCurrentPage} />
        </div>
    );
};
